webpackJsonp([1],Array(18).concat([
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createLog;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_search_params__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_search_params___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_search_params__);
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

var params = __WEBPACK_IMPORTED_MODULE_0_search_params__["parse"](window.location.search.replace(/^\?/, ""));
var shouldPrint = !!params.find(function (param) { return param.name === "show_logs"; });
function createLog(moduleName) {
    return function () {
        var content = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            content[_i] = arguments[_i];
        }
        if (!shouldPrint)
            return;
        console.log.apply(console, __spreadArrays(["[ " + Date() + " ]", "[ " + moduleName + " ]"], content));
    };
}


/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Transceivers */
/* harmony export (immutable) */ __webpack_exports__["e"] = getByIdentifier;
/* harmony export (immutable) */ __webpack_exports__["l"] = getAll;
/* harmony export (immutable) */ __webpack_exports__["c"] = createConnection;
/* harmony export (immutable) */ __webpack_exports__["g"] = setAnswererTransceiversForMaster;
/* harmony export (immutable) */ __webpack_exports__["k"] = setOffererTransceiversForParticipant;
/* harmony export (immutable) */ __webpack_exports__["h"] = setAnswererTransceiversForParticipant;
/* harmony export (immutable) */ __webpack_exports__["o"] = updateAudioTransceiver;
/* harmony export (immutable) */ __webpack_exports__["p"] = updateVideoTransceiver;
/* harmony export (immutable) */ __webpack_exports__["q"] = updateScreenshareTransceiver;
/* harmony export (immutable) */ __webpack_exports__["a"] = closeConnection;
/* harmony export (immutable) */ __webpack_exports__["m"] = closeAll;
/* harmony export (immutable) */ __webpack_exports__["b"] = remove;
/* harmony export (immutable) */ __webpack_exports__["n"] = removeAll;
/* harmony export (immutable) */ __webpack_exports__["f"] = setRemoteDescription;
/* harmony export (immutable) */ __webpack_exports__["i"] = createAnswer;
/* harmony export (immutable) */ __webpack_exports__["d"] = createOffer;
/* harmony export (immutable) */ __webpack_exports__["j"] = createCandidate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__session__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sdp__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bandwidth__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__log__ = __webpack_require__(18);
/**
 * Peer lifecycle management
 * @module Peer
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};





var log = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__log__["a" /* default */])("peers");
var Transceivers = /** @class */ (function () {
    function Transceivers() {
        this.regularAudio = undefined;
        this.regularVideo = undefined;
        this.screenVideo = undefined;
        this.musicAudio = undefined;
    }
    return Transceivers;
}());

var registeredPeers = new Map();
function getByIdentifier(peerIdentifier) {
    return registeredPeers.get(peerIdentifier);
}
// Debug only
function getAll() {
    return registeredPeers;
}
function limitBitrate() {
    var peers = Array.from(getAll().values());
    var peersCount = peers.length;
    log("Limiting bitrate because of peers count:", peersCount);
    var setLimit = function (peer) {
        var connection = peer.connection;
        log("Limiting bitrate for", peer.name, "type:", connection.localDescription.type);
        if (connection.localDescription.type === "offer") {
            connection
                .createOffer({
                offerToReceiveAudio: 1,
                offerToReceiveVideo: 1,
            })
                .then(function (e) {
                return connection.setLocalDescription(e);
            })
                .then(function () {
                var sdp = connection.remoteDescription.sdp;
                connection.setRemoteDescription(new RTCSessionDescription({
                    type: "answer",
                    sdp: __WEBPACK_IMPORTED_MODULE_3__bandwidth__["a" /* setMediaBitrate */](sdp, "video"),
                }));
            })["catch"](function (error) {
                console.error(error);
                console.error("invalid sdp:", __WEBPACK_IMPORTED_MODULE_3__bandwidth__["a" /* setMediaBitrate */](connection.remoteDescription.sdp, "video"));
            });
        }
        if ("answer" === connection.localDescription.type) {
            connection
                .setRemoteDescription(new RTCSessionDescription({
                type: "offer",
                sdp: __WEBPACK_IMPORTED_MODULE_3__bandwidth__["a" /* setMediaBitrate */](connection.remoteDescription.sdp, "video"),
            }))
                .then(function () {
                return connection.createAnswer();
            })
                .then(function (e) {
                return connection.setLocalDescription(e);
            })["catch"](function (error) { return console.error("Error while limiting bandwidth and creating answer", error); });
        }
    };
    peers.forEach(function (peer) {
        if (peer.pendingLimit) {
            clearInterval(peer.pendingLimit);
        }
        var hasEmptyLocalDescription = function (_a) {
            var connection = _a.connection;
            if (!connection.localDescription)
                return true;
            return !connection.localDescription.type;
        };
        if (peer.connection.signalingState !== "stable" ||
            hasEmptyLocalDescription(peer) ||
            peer.connection.iceConnectionState.toString() !== "stable") {
            log("Connection not stable for", peer.name, " - waiting...");
            peer.pendingLimit = setInterval(function () {
                if (peer.connection.signalingState !== "stable" ||
                    hasEmptyLocalDescription(peer) ||
                    peer.connection.iceConnectionState.toString() !== "stable") {
                    return;
                }
                setLimit(peer);
                clearInterval(peer.pendingLimit);
            }, 250);
            return;
        }
        setLimit(peer);
    });
}
/**
 * Creates new RTCPeerConnection
 */
function createConnection(session, peerIdentifier, peerName, reconnectCount, master, supportMusic, supportSimultaneousScreen) {
    var _this = this;
    var peer = {
        identifier: peerIdentifier,
        connection: new RTCPeerConnection({ iceServers: session.iceServers }),
        name: peerName,
        stream: null,
        isSuspended: false,
        onReady: function () { },
        pendingLimit: null,
        master: master,
        supportMusic: master && supportMusic,
        screenStream: null,
        supportSimultaneousScreen: supportSimultaneousScreen,
        transceivers: new Transceivers(),
        lastResult: null,
        isLocal: peerName === "local",
        localConnectionType: "",
        remoteConnectionType: "",
        reconnectCount: reconnectCount,
        bandwidthStatsTicker: null,
    };
    var connection = peer.connection;
    connection.onicecandidate = function (_a) {
        var candidate = _a.candidate;
        // REND-50: standard allows candidate.candidate to be empty string
        // but this causes Safari to throw parsing error. Workaround is to
        // not send empty string candidates (only FF send them).
        if (!candidate || !candidate.candidate)
            return;
        __WEBPACK_IMPORTED_MODULE_0__session__["a" /* send */](session, "ice", {
            peersIdentifier: peerIdentifier,
            sdp: candidate.candidate,
            sdpMid: candidate.sdpMid,
            sdpMLineIndex: candidate.sdpMLineIndex,
        });
    };
    connection.onsignalingstatechange = function () {
        log("Signaling state for " + peer.name + ":", connection.signalingState);
    };
    connection.ontrack = function (event) {
        // Audio and video mids are present only for Wirecast Go compatibility.
        if ((event.transceiver.mid == "0" || event.transceiver.mid == "audio") || (event.transceiver.mid == "1" || event.transceiver.mid == "video")) {
            log("Adding remote stream for", peer.name);
            peer.stream = event.streams[0];
            peer.onReady();
            peer.onReady = function () { };
        }
        else {
            log("Adding remote screen stream for", peer.name);
            peer.screenStream = event.streams[0];
            event.streams[0].onremovetrack = function () {
                event.streams[0].onremovetrack = null;
                peer.screenStream = null;
            };
        }
    };
    registeredPeers.set(peerIdentifier, peer);
    log("Created connection for", peerName);
    // Bandwidth debug peer stats
    clearInterval(peer.bandwidthStatsTicker);
    peer.bandwidthStatsTicker = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
        var stats;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, connection.getStats(null)];
                case 1:
                    stats = _a.sent();
                    stats.forEach(function (report) {
                        var now = report.timestamp;
                        if (report.type === "outboundrtp" ||
                            report.type === "outbound-rtp" ||
                            (report.type === "ssrc" && report.bytesSent)) {
                            var bytes = report.bytesSent;
                            var packets = report.packetsSent;
                            if (peer.lastResult && peer.lastResult.get(report.id)) {
                                // calculate bitrate
                                var bitrate = (8 * (bytes - peer.lastResult.get(report.id).bytesSent)) /
                                    (now - peer.lastResult.get(report.id).timestamp);
                                if (bitrate && typeof peer.onBitrateChange === "function") {
                                    peer.onBitrateChange(bitrate.toFixed());
                                }
                            }
                        }
                    });
                    peer.lastResult = stats;
                    return [2 /*return*/];
            }
        });
    }); }, 1000);
    limitBitrate();
    return peer;
}
function setAnswererTransceivers(peer, localStream) {
    log("Setting answerer transceivers to connection", peer.name);
    var audioTrack = localStream.getAudioTracks()[0];
    var videoTrack = localStream.getVideoTracks()[0];
    // As an answerer, reuse already existing transceivers
    // Audio and video mids are present only for Wirecast Go compatibility.
    peer.transceivers.regularAudio = peer.connection.getTransceivers().find(function (t) { return t.mid == '0' || t.mid == 'audio'; });
    peer.transceivers.regularAudio.sender.setStreams(localStream);
    peer.transceivers.regularAudio.direction = "sendrecv";
    peer.transceivers.regularVideo = peer.connection.getTransceivers().find(function (t) { return t.mid == '1' || t.mid == 'video'; });
    peer.transceivers.regularVideo.sender.setStreams(localStream);
    peer.transceivers.regularVideo.direction = "sendrecv";
    if (audioTrack) {
        peer.transceivers.regularAudio.sender.replaceTrack(audioTrack);
    }
    if (videoTrack) {
        peer.transceivers.regularVideo.sender.replaceTrack(videoTrack);
    }
    else {
        peer.transceivers.regularVideo.sender.replaceTrack(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* getDummyVideoTrack */]());
    }
}
function setAnswererTransceiversForMaster(peer, localStream) {
    if (!peer.master) {
        return;
    }
    setAnswererTransceivers(peer, localStream);
    // Add additional transceiver for peers supporting music audio - for now Wirecast only
    if (peer.supportMusic) {
        peer.transceivers.musicAudio = peer.connection.addTransceiver("audio", { direction: "inactive", streams: [localStream] });
    }
}
function setOffererTransceiversForParticipant(peer, localStream) {
    if (peer.master) {
        return;
    }
    log("Setting transceivers to connection", peer.name);
    var audioTrack = localStream.getAudioTracks()[0];
    var videoTrack = localStream.getVideoTracks()[0];
    if (audioTrack) {
        peer.transceivers.regularAudio = peer.connection.addTransceiver(audioTrack, { direction: "sendrecv", streams: [localStream] });
    }
    else {
        peer.transceivers.regularAudio = peer.connection.addTransceiver("audio", { direction: "sendrecv", streams: [localStream] });
    }
    if (videoTrack) {
        peer.transceivers.regularVideo = peer.connection.addTransceiver(videoTrack, { direction: "sendrecv", streams: [localStream] });
    }
    else {
        peer.transceivers.regularVideo = peer.connection.addTransceiver(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* getDummyVideoTrack */](), { direction: "sendrecv", streams: [localStream] });
    }
}
function setAnswererTransceiversForParticipant(peer, localStream) {
    if (peer.master) {
        return;
    }
    setAnswererTransceivers(peer, localStream);
}
function updateAudioTransceiver(peer, stream, audioProcessingDisabled) {
    if (peer.isLocal)
        return;
    if (typeof peer.connection.getTransceivers === "function") {
        var audioTrack = stream.getAudioTracks()[0];
        var regularAudioTransceiver = peer.transceivers.regularAudio;
        var enhancedAudioTransceiver = peer.transceivers.musicAudio;
        if (audioTrack && regularAudioTransceiver) {
            if (peer.master && enhancedAudioTransceiver) {
                if (audioProcessingDisabled) {
                    regularAudioTransceiver.sender.replaceTrack(null);
                    regularAudioTransceiver.direction = "recvonly";
                    enhancedAudioTransceiver.sender.replaceTrack(audioTrack);
                    enhancedAudioTransceiver.direction = "sendonly";
                }
                else {
                    regularAudioTransceiver.sender.replaceTrack(audioTrack);
                    regularAudioTransceiver.direction = "sendrecv";
                    enhancedAudioTransceiver.sender.replaceTrack(null);
                    enhancedAudioTransceiver.direction = "inactive";
                }
            }
            else {
                regularAudioTransceiver.sender.replaceTrack(audioTrack);
            }
        }
    }
}
function updateVideoTransceiver(peer, stream) {
    if (typeof peer.connection.getTransceivers === "function") {
        var videoTrack = stream.getVideoTracks()[0];
        var videoTransceiver = peer.transceivers.regularVideo;
        if (videoTrack && videoTransceiver) {
            videoTransceiver.sender.replaceTrack(videoTrack);
        }
    }
}
function updateScreenshareTransceiver(peer, stream, sharingScreenAndVideo) {
    if (typeof peer.connection.getTransceivers === "function") {
        if (sharingScreenAndVideo && stream && stream.getVideoTracks()[0]) {
            if (!peer.transceivers.screenVideo) {
                if (peer.master) {
                    peer.transceivers.screenVideo = peer.connection.addTransceiver(stream.getVideoTracks()[0], { direction: "sendonly" });
                }
                else {
                    peer.transceivers.screenVideo = peer.connection.addTransceiver(stream.getVideoTracks()[0], { direction: "sendonly", streams: [stream] });
                }
            }
            else {
                peer.transceivers.screenVideo.sender.replaceTrack(stream.getVideoTracks()[0]);
                peer.transceivers.screenVideo.direction = "sendonly";
            }
        }
        else {
            if (peer.transceivers.screenVideo) {
                peer.transceivers.screenVideo.sender.replaceTrack(null);
                peer.transceivers.screenVideo.direction = "recvonly";
            }
        }
    }
}
function closeConnection(peer) {
    log("Closing connection", peer.name);
    // Stop bandwidth debug peer stats reports
    clearInterval(peer.bandwidthStatsTicker);
    peer.connection.close();
}
function closeAll() {
    registeredPeers.forEach(function (value) { return closeConnection(value); });
    log("Closed all connections");
}
function remove(peer) {
    log("Removing peer from registry", peer.name);
    registeredPeers["delete"](peer.identifier);
}
function removeAll() {
    registeredPeers.clear();
    log("Removed all peers", registeredPeers);
}
function setRemoteDescription(_a, description) {
    var connection = _a.connection;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            description.sdp = __WEBPACK_IMPORTED_MODULE_3__bandwidth__["a" /* setMediaBitrate */](description.sdp, "video");
            description.sdp = __WEBPACK_IMPORTED_MODULE_1__sdp__["a" /* modifySdpForMusic */](description.sdp);
            return [2 /*return*/, connection.setRemoteDescription(new RTCSessionDescription(description))];
        });
    });
}
function createAnswer($socket, peer) {
    return __awaiter(this, void 0, void 0, function () {
        var answer;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, peer.connection.createAnswer()];
                case 1:
                    answer = _a.sent();
                    answer.sdp = __WEBPACK_IMPORTED_MODULE_1__sdp__["b" /* preferH264 */](answer.sdp);
                    answer.sdp = __WEBPACK_IMPORTED_MODULE_3__bandwidth__["a" /* setMediaBitrate */](answer.sdp, "video");
                    return [4 /*yield*/, peer.connection.setLocalDescription(answer)];
                case 2:
                    _a.sent();
                    log("Creating answer", peer.name);
                    __WEBPACK_IMPORTED_MODULE_0__session__["a" /* send */]($socket.session, "createdAnswer", {
                        sdp: answer.sdp,
                        type: answer.type,
                        sessionGuid: $socket.session.sessionGuid,
                        peersIdentifier: peer.identifier,
                    });
                    return [2 /*return*/];
            }
        });
    });
}
function createOffer(session, peer) {
    return __awaiter(this, void 0, void 0, function () {
        var offer;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, peer.connection.createOffer()];
                case 1:
                    offer = _a.sent();
                    offer.sdp = __WEBPACK_IMPORTED_MODULE_1__sdp__["b" /* preferH264 */](offer.sdp);
                    return [4 /*yield*/, peer.connection.setLocalDescription(offer)];
                case 2:
                    _a.sent();
                    log("Creating offer", peer.name);
                    __WEBPACK_IMPORTED_MODULE_0__session__["a" /* send */](session, "peerMadeOffer", {
                        sdp: offer.sdp,
                        type: offer.type,
                        peersIdentifier: peer.identifier,
                    });
                    return [2 /*return*/];
            }
        });
    });
}
function createCandidate(peer, candidateOptions) {
    return __awaiter(this, void 0, void 0, function () {
        var candidate, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    candidate = new RTCIceCandidate({
                        sdpMLineIndex: candidateOptions.sdpMLineIndex,
                        sdpMid: candidateOptions.sdpMid,
                        candidate: candidateOptions.sdp,
                    });
                    log("Creating ICE candidate", peer.name);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, peer.connection.addIceCandidate(candidate)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    console.error("Adding ICE candidate failed", e_1, "candidate", candidate, "sdp", candidateOptions.sdp);
                    throw e_1;
                case 4: return [2 /*return*/];
            }
        });
    });
}


/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = enableScreenAndVideo;
/* harmony export (immutable) */ __webpack_exports__["a"] = enableScreenOnly;
/* harmony export (immutable) */ __webpack_exports__["b"] = stopScreen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__log__ = __webpack_require__(18);
/**
 * Perform screenshare-releated actions.
 * @module Screenshare
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var log = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__log__["a" /* default */])("screenshare");
function getScreenStream($store) {
    return __awaiter(this, void 0, void 0, function () {
        var stream;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    stream = $store.getters.localScreenStream;
                    if (!!stream) return [3 /*break*/, 2];
                    return [4 /*yield*/, window.navigator.mediaDevices.getDisplayMedia({
                            video: {
                                cursor: "always",
                            },
                            audio: false,
                        })];
                case 1:
                    stream = _a.sent();
                    $store.dispatch("setLocalScreenStream", stream);
                    _a.label = 2;
                case 2: return [2 /*return*/, stream];
            }
        });
    });
}
function configureStreamForScreenAndVideo($store, $socket) {
    return __awaiter(this, void 0, void 0, function () {
        var stream, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getScreenStream($store)];
                case 1:
                    stream = _a.sent();
                    stream.getVideoTracks()[0].addEventListener("ended", function () {
                        // The sharing was ended e.g. by clicking the chrome "Stop Sharing" button.
                        if ($store.getters.sharingScreenAndVideo) {
                            disableScreenAndVideo($store, $socket);
                            $store.dispatch("setLocalScreenStream", null);
                        }
                    });
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    $store.dispatch("setScreenShareError", err_1.message);
                    $store.dispatch("setLocalScreenStream", null);
                    $store.dispatch("updateSharingScreenAndVideo", false);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function configureStreamForScreenOnly($store) {
    return __awaiter(this, void 0, void 0, function () {
        var stream, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getScreenStream($store)];
                case 1:
                    stream = _a.sent();
                    $store.dispatch("updateCurrentVideoDevice", { deviceId: "screen" });
                    stream.getVideoTracks()[0].addEventListener("ended", function () {
                        // The sharing was ended e.g. by clicking the chrome "Stop Sharing" button.
                        if ($store.getters.sharingScreenOnly) {
                            disableScreenOnly($store);
                            $store.dispatch("setLocalScreenStream", null);
                        }
                    });
                    return [3 /*break*/, 3];
                case 2:
                    err_2 = _a.sent();
                    $store.commit("screenShareError", err_2.message);
                    $store.dispatch("setLocalScreenStream", null);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function enableScreenAndVideo($store, $socket) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if ($store.getters.sharingScreenOnly) {
                        disableScreenOnly($store);
                    }
                    // Clear previous screenshare errors
                    $store.dispatch("setScreenShareError", undefined);
                    return [4 /*yield*/, configureStreamForScreenAndVideo($store, $socket)];
                case 1:
                    _a.sent();
                    if (!$store.getters.localScreenStream) {
                        return [2 /*return*/];
                    }
                    $socket.sendWithoutSession("updateSharingState", {
                        enabled: true,
                    });
                    return [2 /*return*/];
            }
        });
    });
}
function disableScreenAndVideo($store, $socket) {
    $socket.sendWithoutSession("updateSharingState", {
        enabled: false,
    });
    $store.dispatch("updateSharingScreenAndVideo", false);
}
function enableScreenOnly($store, $socket) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if ($store.getters.sharingScreenAndVideo) {
                        disableScreenAndVideo($store, $socket);
                    }
                    // Clear previous device and screenshare errors
                    $store.dispatch("setVideoDeviceError", { errorId: undefined, deviceName: undefined });
                    $store.dispatch("setScreenShareError", undefined);
                    return [4 /*yield*/, configureStreamForScreenOnly($store)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function disableScreenOnly($store) {
    $store.dispatch("updateCurrentVideoDevice", { deviceId: undefined });
}
function stopScreen($store, $socket) {
    if ($store.getters.sharingScreenAndVideo) {
        disableScreenAndVideo($store, $socket);
    }
    else if ($store.getters.sharingScreenOnly) {
        disableScreenOnly($store);
    }
    // Stop screen track
    var stream = $store.getters.localScreenStream;
    if (stream && stream.getVideoTracks()[0]) {
        stream.getVideoTracks()[0].stop();
    }
    $store.dispatch("setScreenShareError", undefined);
    $store.dispatch("setLocalScreenStream", null);
}


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(313)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(366),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3f3118d0",
  /* moduleIdentifier (server only) */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(148)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = getInputDevices;
/* harmony export (immutable) */ __webpack_exports__["f"] = filterDevicesByKind;
/* harmony export (immutable) */ __webpack_exports__["g"] = getAudioTrackForDevice;
/* harmony export (immutable) */ __webpack_exports__["h"] = getVideoTrackForDevice;
/* harmony export (immutable) */ __webpack_exports__["b"] = getPreferredDevices;
/* harmony export (immutable) */ __webpack_exports__["d"] = setPreferredDevices;
/* harmony export (immutable) */ __webpack_exports__["a"] = findDeviceById;
/* harmony export (immutable) */ __webpack_exports__["c"] = getDefaultFromList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__frame_rate__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__log__ = __webpack_require__(18);
/**
 * Perform device-releated actions (get list of devices, getUserMedia, etc.)
 * @module Device
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



var log = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__log__["a" /* default */])("device");
function getInputDevices() {
    return __awaiter(this, void 0, void 0, function () {
        var devices, requestPermissionsNeeded, audioDevicesPresent, videoDevicesPresent, stream, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, navigator.mediaDevices.enumerateDevices()];
                case 1:
                    devices = _a.sent();
                    requestPermissionsNeeded = devices.some(function (device) { return device.deviceId === '' || device.label === ''; });
                    if (!requestPermissionsNeeded) return [3 /*break*/, 7];
                    audioDevicesPresent = devices.some(function (device) { return device.kind === 'audioinput'; });
                    videoDevicesPresent = devices.some(function (device) { return device.kind === 'videoinput'; });
                    stream = void 0;
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, navigator.mediaDevices.getUserMedia({ audio: audioDevicesPresent, video: videoDevicesPresent })];
                case 3:
                    stream = _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    if (error_1.name != "NotAllowedError") {
                        log("Can not list input devices. GetUserMedia error: ", error_1.name);
                    }
                    throw error_1;
                case 5: return [4 /*yield*/, navigator.mediaDevices.enumerateDevices()];
                case 6:
                    devices = _a.sent();
                    stream.getTracks().forEach(function (track) {
                        track.stop();
                    });
                    _a.label = 7;
                case 7: 
                // Only return: 1) input devices, 2) devices with compatible kind (audio or video), 3) devices with valid id and label
                return [2 /*return*/, devices.filter(function (_a) {
                        var kind = _a.kind, deviceId = _a.deviceId, label = _a.label;
                        return /input/.test(kind) && deviceId !== "" && label !== "";
                    })];
            }
        });
    });
}
function filterDevicesByKind(devicesType, devices) {
    return devices.filter(function (_a) {
        var kind = _a.kind;
        return new RegExp(devicesType).test(kind);
    });
}
function getAudioTrackForDevice(audioDevice, audioProcessingDisabled) {
    return __awaiter(this, void 0, void 0, function () {
        var audioDeviceId, audioConstraints, audioStream;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    audioDeviceId = audioDevice.deviceId;
                    if (!audioDeviceId) {
                        return [2 /*return*/, null];
                    }
                    audioConstraints = {
                        audio: {
                            deviceId: audioDeviceId ? { exact: audioDeviceId } : undefined,
                            autoGainControl: { ideal: false },
                            echoCancellation: { ideal: !audioProcessingDisabled },
                            noiseSuppression: { ideal: !audioProcessingDisabled }
                        },
                        video: false
                    };
                    return [4 /*yield*/, navigator.mediaDevices.getUserMedia(audioConstraints)];
                case 1:
                    audioStream = _a.sent();
                    if (!audioStream) {
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/, audioStream.getAudioTracks()[0]];
            }
        });
    });
}
function getVideoTrackForDevice(videoDevice) {
    return __awaiter(this, void 0, void 0, function () {
        var videoDeviceId, frameRateValue, frameRateConstraint, constrains, videoStream;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    videoDeviceId = videoDevice.deviceId;
                    if (!videoDeviceId) {
                        return [2 /*return*/, null];
                    }
                    frameRateValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__frame_rate__["a" /* getFrameRate */])();
                    frameRateConstraint = frameRateValue ? { frameRate: { max: frameRateValue } } : {};
                    if (frameRateValue) {
                        log("Will use " + frameRateValue + " FPS");
                    }
                    constrains = {
                        video: __assign({ deviceId: videoDeviceId ? { exact: videoDeviceId } : undefined, width: { max: 1280, ideal: 1280, min: 1280 / 4 }, height: { max: 720, ideal: 720, min: 720 / 4 } }, frameRateConstraint),
                        audio: false,
                    };
                    return [4 /*yield*/, navigator.mediaDevices.getUserMedia(constrains)];
                case 1:
                    videoStream = _a.sent();
                    if (!videoStream) {
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/, videoStream.getVideoTracks()[0]];
            }
        });
    });
}
function getPreferredDevices() {
    return {
        videoDeviceId: __WEBPACK_IMPORTED_MODULE_0_js_cookie__["get"]("net.telestream.webrtc.selectedVideoDeviceId"),
        audioDeviceId: __WEBPACK_IMPORTED_MODULE_0_js_cookie__["get"]("net.telestream.webrtc.selectedAudioDeviceId"),
    };
}
function setPreferredDevices(_a) {
    var video = _a.video, audio = _a.audio;
    if (video) {
        __WEBPACK_IMPORTED_MODULE_0_js_cookie__["set"]("net.telestream.webrtc.selectedVideoDeviceId", video);
    }
    if (audio) {
        __WEBPACK_IMPORTED_MODULE_0_js_cookie__["set"]("net.telestream.webrtc.selectedAudioDeviceId", audio);
    }
}
/**
 * Find device by device ID among other devices
 * @param {string} deviceToFindId - id of the device to find
 */
function findDeviceById(deviceToFindId, allDevices) {
    return allDevices.find(function (device) { return device.deviceId === deviceToFindId; });
}
function getDefaultFromList(preferredDeviceId, deviceList, store) {
    if (!deviceList || deviceList.length === 0)
        return undefined;
    var foundDevice = findDeviceById(preferredDeviceId, deviceList);
    if (foundDevice) {
        return foundDevice.deviceId;
    }
    return deviceList[0].deviceId;
}


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = init;
/* harmony export (immutable) */ __webpack_exports__["a"] = send;
/* harmony export (immutable) */ __webpack_exports__["c"] = receive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__guid__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__peers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ice__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__log__ = __webpack_require__(18);
/**
 * Establish websocket connection, expose helper functions to send and receive
 * messages
 * @module Session
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




var log = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__log__["a" /* default */])("session");
function createWebSocket(onOpen, onClose, getAppState) {
    log("Creating new websocket");
    var host = window.location.host;
    if (false) {
        host = process.env.SOCKET_URL;
    }
    var socket = new WebSocket("wss://" + host + ":443");
    socket.onopen = onOpen(socket);
    socket.onclose = function () {
        log("Socket closed");
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__peers__["m" /* closeAll */])();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__peers__["n" /* removeAll */])();
        onClose();
        if (getAppState() === "disconnected") {
            log("Has been disconnected from session, no reconnect attempt");
            return;
        }
        setTimeout(function () {
            log("Reconnecting...");
            createWebSocket(onOpen, onClose, getAppState);
        }, 5 * 1000);
    };
    return socket;
}
function init(options, onMessage) {
    var peerGuid = __WEBPACK_IMPORTED_MODULE_0__guid__["a" /* getPeerGuid */]() || __WEBPACK_IMPORTED_MODULE_0__guid__["b" /* createPeerGuid */]();
    var sessionGuid = __WEBPACK_IMPORTED_MODULE_0__guid__["c" /* getSessionGuid */]();
    var onOpen = function (socket) { return function () {
        log("<- Joining");
        session.socket = socket;
        socket.onmessage = onMessage;
        send(session, "joinPeer", __assign({ peersIdentifier: peerGuid }, options));
    }; };
    var session = {
        socket: createWebSocket(onOpen, options.onClose, options.getAppState),
        sessionGuid: sessionGuid,
        peerGuid: peerGuid,
        iceServers: __WEBPACK_IMPORTED_MODULE_2__ice__["a" /* servers */],
    };
    return session;
}
function send(session, action, payload) {
    var json = JSON.stringify(__assign({ action: action, sessionGuid: session.sessionGuid }, payload));
    session.socket.send(json);
}
function receive(receiverFn) {
    return function (event) {
        var _a = JSON.parse(event.data), action = _a.action, payload = __rest(_a, ["action"]);
        receiverFn(action, payload);
    };
}


/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDummyVideoTrack;
/* harmony export (immutable) */ __webpack_exports__["b"] = stopDummyVideoTrack;
/**
 * Utils
 * @module Utils
 */
var dummyVideoTrack = null;
var dummyTrackInterval = null;
var canvas = null;
// It is used at the begining of connection, if video track is not yet available.
// Without that video player on remote peer may not start playing audio/video content
function getDummyVideoTrack() {
    if (!dummyVideoTrack) {
        canvas = document.createElement("canvas");
        // Workaround for FF only: https://bugzilla.mozilla.org/show_bug.cgi?id=1572422
        // canvas.getContext needs to be called before captureStream to avoid
        // NS_ERROR_NOT_INITIALIZED being thrown.
        canvas.getContext('2d');
        var stream = canvas.captureStream();
        dummyVideoTrack = Object.assign(stream.getVideoTracks()[0], { enabled: false });
    }
    var width = 320, height = 180;
    var ctx = canvas.getContext('2d');
    dummyTrackInterval = setInterval(function () {
        ctx.fillRect(0, 0, width, height);
    }, 1000);
    return dummyVideoTrack;
}
function stopDummyVideoTrack() {
    if (dummyTrackInterval) {
        clearInterval(dummyTrackInterval);
        dummyTrackInterval = null;
        return true;
    }
    return false;
}


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(307)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(361),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0ba4e300",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(319)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(372),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8e6d55de",
  /* moduleIdentifier (server only) */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(146)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(309)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(363),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-265371a5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getLanguage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);

var DEFAULT_LANGUAGE = "en";
var supportedLanguages = [
    "en",
    "de" /*, // German
    'es', // Spanish
    'pt-BR', //Brazilian Portugues
    'fr', // French
    'jp' // Japanese
    */,
];
// In which syntax the languageString is in? See for more:
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Accept-Language
function isAnySyntax(languageString) {
    return languageString === "*";
}
function isLanguageSyntax(languageString) {
    return !/-/.test(languageString);
}
function isLocaleSyntax(languageString) {
    return /-/.test(languageString);
}
/*
 * Extract language (e.g. 'en') from local string, like en-US
 */
function extractLanguageFromLocale(locale) {
    return locale.replace(/-[a-z]{2,3}/i, "");
}
/*
 * Extract preffered languages from Accepts-Language content
 */
function extractLanguagesFromHeader(acceptsLanguageString) {
    return acceptsLanguageString
        .replace(/q=[0-9\.]+/g, "") // Remove quality values
        .split(/,[\s]?/); // Turn string to array of language codes
}
function isSupported(language) {
    return supportedLanguages.includes(language);
}
function extractLanguage(acceptsLanguageString) {
    if (!acceptsLanguageString)
        return DEFAULT_LANGUAGE;
    var choices = extractLanguagesFromHeader(acceptsLanguageString)
        .map(function (language) {
        // Special case with Brazilian Portugese
        if (language === "pt-BR")
            return language;
        if (isLanguageSyntax(language))
            return language;
        if (isLocaleSyntax(language))
            return extractLanguageFromLocale(language);
    })
        .filter(isSupported);
    var bestChoice = choices[0];
    if (isAnySyntax(bestChoice))
        return DEFAULT_LANGUAGE;
    return bestChoice;
}
function getLanguage() {
    var cookieValue = __WEBPACK_IMPORTED_MODULE_0_js_cookie__["get"]("lang");
    return extractLanguage(cookieValue) || DEFAULT_LANGUAGE;
}


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__session__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__peers__ = __webpack_require__(28);
/**
 * Plugin that exposes $socket (a simple event bus) in every Vue component we use
 * @module Plugin/Socket
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


/* harmony default export */ __webpack_exports__["a"] = ({
    install: function (Vue, options) {
        var readyPromise = new Promise(function (resolve, reject) {
            var $socket = {
                session: null,
                bus: new Vue(),
                open: function (userName) {
                    var _this = this;
                    // establish websocket connection
                    this.session = __WEBPACK_IMPORTED_MODULE_0__session__["b" /* init */]({
                        username: userName,
                        onClose: function () {
                            options.store.dispatch("clearPeers");
                            __WEBPACK_IMPORTED_MODULE_1__peers__["m" /* closeAll */]();
                            __WEBPACK_IMPORTED_MODULE_1__peers__["n" /* removeAll */]();
                        },
                        getAppState: function () {
                            return options.store.getters.appState;
                        },
                    }, __WEBPACK_IMPORTED_MODULE_0__session__["c" /* receive */](this.bus.$emit.bind(this.bus)));
                    // this.session.socket is the real socket here
                    this.session.socket.onerror = function (error) {
                        if (typeof options.onError === "function") {
                            options.onError(error);
                            return;
                        }
                        throw error;
                    };
                    // set session guid and resolve readyPromise when connection
                    // is established and we get a response from server
                    this.bus.$on("joinPeerResponse", function (payload) {
                        if (payload.sessionGuid) {
                            _this.session.sessionGuid = payload.sessionGuid;
                        }
                        if (payload.chatEnabled) {
                            options.store.dispatch("enableChat", { peersIdentifier: payload.peersIdentifier });
                        }
                        else {
                            options.store.dispatch("disableChat");
                        }
                        if (payload.supportMusic) {
                            options.store.dispatch("updateSupportMusic", true);
                        }
                        if (payload.supportSimultaneousScreen) {
                            options.store.dispatch("updateSupportSimultaneousScreen", true);
                        }
                        if (payload.iceServers) {
                            _this.session.iceServers = payload.iceServers.map(function (entry) {
                                return entry.url.startsWith("turn:")
                                    ? {
                                        urls: [entry.url],
                                        username: entry.turnUsername,
                                        credential: entry.turnPassword,
                                    }
                                    : { urls: [entry.url] };
                            });
                        }
                        resolve({
                            session: _this.session,
                            socket: _this.session.socket,
                        });
                    });
                },
                on: function (message, listener) {
                    this.bus.$on(message, listener);
                },
                send: function (message, payload) {
                    __WEBPACK_IMPORTED_MODULE_0__session__["a" /* send */](this.session, message, payload);
                },
                sendWithoutSession: function (action, payload) {
                    var messageJson = JSON.stringify(__assign({ action: action }, payload));
                    this.session.socket.send(messageJson);
                },
                whenReady: function () {
                    return readyPromise;
                },
            };
            Vue.prototype.$socket = $socket;
        });
    },
});


/***/ }),
/* 138 */
/***/ (function(module, exports) {

if (!Array.prototype.includes) {
    Array.prototype.includes = function (itemToTest) {
        return !!this.find(function (item) { return item === itemToTest; });
    };
}
if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__device__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__peers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chat__ = __webpack_require__(344);
/**
 * Our state store
 * @module Store
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */]);
var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */].Store({
    modules: {
        chat: __WEBPACK_IMPORTED_MODULE_5__chat__["a" /* default */],
    },
    state: {
        appState: "pure",
        errors: {
            fatal: null,
            minor: undefined,
            device: undefined,
            audioDevice: {
                errorId: undefined,
                deviceName: undefined,
            },
            videoDevice: {
                errorId: undefined,
                deviceName: undefined,
            },
        },
        devices: {
            video: [],
            audio: [],
            current: {
                video: null,
                audio: null,
            },
        },
        streams: {
            local: null,
            updated: false,
        },
        localScreenStream: null,
        defaultLocalUserName: "You",
        localUserName: "You",
        peers: [],
        screenShareError: null,
        sharingScreenAndVideo: false,
        bitrateLimitPeerCount: 0,
        videoFlipped: false,
        audioProcessingDisabled: false,
        supportMusic: false,
        localAudioEnabled: true,
        supportSimultaneousScreen: false,
        screenTallyActive: false,
    },
    getters: {
        appState: function (state) {
            return state.appState;
        },
        fatalError: function (state) {
            return state.errors.fatal;
        },
        minorError: function (state) {
            return state.errors.minor;
        },
        deviceError: function (state) {
            return state.errors.device;
        },
        audioDeviceError: function (state) {
            return state.errors.audioDevice;
        },
        videoDeviceError: function (state) {
            return state.errors.videoDevice;
        },
        videoDevices: function (state) {
            return state.devices.video;
        },
        audioDevices: function (state) {
            return state.devices.audio;
        },
        currentVideoDevice: function (state) {
            return state.devices.current.video;
        },
        currentAudioDevice: function (state) {
            return state.devices.current.audio;
        },
        preferredVideoDevice: function () {
            return __WEBPACK_IMPORTED_MODULE_2__device__["b" /* getPreferredDevices */]().videoDeviceId;
        },
        preferredAudioDevice: function () {
            return __WEBPACK_IMPORTED_MODULE_2__device__["b" /* getPreferredDevices */]().audioDeviceId;
        },
        localStream: function (state) {
            return state.streams.local;
        },
        localStreamUpdated: function (state) {
            return state.streams.updated;
        },
        localScreenStream: function (state) {
            return state.localScreenStream;
        },
        defaultLocalUserName: function (state) {
            return state.defaultLocalUserName;
        },
        localUserName: function (state) {
            return state.localUserName;
        },
        peers: function (state) {
            return __spreadArrays(state.peers);
        },
        screenShareError: function (state) {
            return state.screenShareError;
        },
        sharingScreenAndVideo: function (state) {
            return state.sharingScreenAndVideo;
        },
        sharingScreenOnly: function (state) {
            if (state.devices.current.video) {
                return state.devices.current.video.deviceId === "screen";
            }
            return false;
        },
        bitrateLimitPeerCount: function (state) {
            return state.bitrateLimitPeerCount;
        },
        videoFlipped: function (state) {
            return state.videoFlipped;
        },
        audioProcessingDisabled: function (state) {
            return state.audioProcessingDisabled;
        },
        supportMusic: function (state) {
            return state.supportMusic;
        },
        localAudioEnabled: function (state) {
            return state.localAudioEnabled;
        },
        supportSimultaneousScreen: function (state) {
            return state.supportSimultaneousScreen;
        },
        supportScreensharing: function () {
            return navigator.mediaDevices && "getDisplayMedia" in navigator.mediaDevices;
        },
        screenTallyActive: function (state) {
            return state.screenTallyActive;
        },
    },
    mutations: {
        appState: function (state, newState) {
            state.appState = newState;
        },
        fatalError: function (state, errorId) {
            state.errors.fatal = errorId;
        },
        minorError: function (state, error) {
            state.errors.minor = error;
        },
        deviceError: function (state, error) {
            state.errors.device = error;
        },
        audioDeviceError: function (state, error) {
            state.errors.audioDevice.errorId = error.errorId;
            state.errors.audioDevice.deviceName = error.deviceName;
        },
        videoDeviceError: function (state, error) {
            state.errors.videoDevice.errorId = error.errorId;
            state.errors.videoDevice.deviceName = error.deviceName;
        },
        videoDevices: function (state, devices) {
            state.devices.video = devices;
        },
        audioDevices: function (state, devices) {
            state.devices.audio = devices;
        },
        currentVideoDevice: function (state, device) {
            state.devices.current.video = device;
        },
        currentAudioDevice: function (state, device) {
            state.devices.current.audio = device;
        },
        localStream: function (state, stream) {
            state.streams.local = stream;
            state.streams.updated = true;
        },
        localStreamUpdated: function (state, updated) {
            state.streams.updated = updated;
        },
        localScreenStream: function (state, screenStream) {
            state.localScreenStream = screenStream;
        },
        preferredVideoDevice: function (_, deviceId) {
            __WEBPACK_IMPORTED_MODULE_2__device__["d" /* setPreferredDevices */]({ video: deviceId });
        },
        preferredAudioDevice: function (_, deviceId) {
            __WEBPACK_IMPORTED_MODULE_2__device__["d" /* setPreferredDevices */]({ audio: deviceId });
        },
        localUserName: function (state, newName) {
            state.localUserName = newName;
        },
        peers: function (state, peers) {
            state.peers = peers;
        },
        screenShareError: function (state, val) {
            state.screenShareError = val;
        },
        sharingScreenAndVideo: function (state, newValue) {
            state.sharingScreenAndVideo = newValue;
        },
        bitrateLimitPeerCount: function (state, newValue) {
            state.bitrateLimitPeerCount = newValue;
        },
        videoFlipped: function (state, newValue) {
            state.videoFlipped = newValue;
        },
        audioProcessingDisabled: function (state, newValue) {
            state.audioProcessingDisabled = newValue;
        },
        supportMusic: function (state, newValue) {
            state.supportMusic = newValue;
        },
        localAudioEnabled: function (state, newValue) {
            state.localAudioEnabled = newValue;
        },
        supportSimultaneousScreen: function (state, newValue) {
            state.supportSimultaneousScreen = newValue;
        },
        screenTallyActive: function (state, newValue) {
            state.screenTallyActive = newValue;
        },
    },
    actions: {
        updateAppState: function (_a, newState) {
            var commit = _a.commit;
            commit("appState", newState);
        },
        setFatalError: function (_a, errorId) {
            var commit = _a.commit;
            commit("fatalError", errorId);
        },
        setMinorError: function (_a, error) {
            var commit = _a.commit;
            commit("minorError", error);
        },
        setDeviceError: function (_a, error) {
            var commit = _a.commit;
            commit("deviceError", error);
        },
        setAudioDeviceError: function (_a, error) {
            var commit = _a.commit;
            commit("audioDeviceError", error);
        },
        setVideoDeviceError: function (_a, error) {
            var commit = _a.commit;
            commit("videoDeviceError", error);
        },
        setScreenShareError: function (_a, error) {
            var commit = _a.commit;
            commit("screenShareError", error);
        },
        setLocalScreenStream: function (_a, screenStream) {
            var commit = _a.commit;
            commit("localScreenStream", screenStream);
        },
        loadInputDevices: function (_a) {
            var commit = _a.commit, dispatch = _a.dispatch, state = _a.state;
            return __awaiter(this, void 0, void 0, function () {
                var devices, error_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_2__device__["e" /* getInputDevices */]()];
                        case 1:
                            devices = _b.sent();
                            commit("audioDevices", __WEBPACK_IMPORTED_MODULE_2__device__["f" /* filterDevicesByKind */]("audio", devices));
                            commit("videoDevices", __WEBPACK_IMPORTED_MODULE_2__device__["f" /* filterDevicesByKind */]("video", devices));
                            dispatch("setDeviceError", undefined);
                            if (state.streams.local == null) {
                                if (devices.length) {
                                    commit("localStream", new MediaStream());
                                }
                                else {
                                    dispatch("setDeviceError", "NO_DEVICES");
                                }
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _b.sent();
                            if (error_1.name == "NotAllowedError") {
                                dispatch("setDeviceError", "NOT_ALLOWED");
                            }
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        updateCurrentVideoDevice: function (_a, device) {
            var commit = _a.commit, dispatch = _a.dispatch, state = _a.state;
            var previousDevice = state.devices.current.video;
            commit("currentVideoDevice", device);
            dispatch("updateLocalVideoTrack", previousDevice);
            if (device && device.deviceId && device.deviceId !== "screen") {
                dispatch("preferredVideoDevice", device.deviceId);
            }
        },
        updateCurrentAudioDevice: function (_a, device) {
            var commit = _a.commit, dispatch = _a.dispatch;
            commit("currentAudioDevice", device);
            dispatch("updateLocalAudioTrack");
            if (device && device.deviceId) {
                dispatch("preferredAudioDevice", device.deviceId);
            }
        },
        updateLocalAudioTrack: function (_a) {
            var commit = _a.commit, dispatch = _a.dispatch, state = _a.state;
            return __awaiter(this, void 0, void 0, function () {
                var audioDevice, audioProcessingDisabled, catchAudioDeviceError, getAudioTrack, currentStream, audioTrack;
                var _this = this;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            audioDevice = state.devices.current.audio || { deviceId: undefined };
                            audioProcessingDisabled = state.audioProcessingDisabled;
                            catchAudioDeviceError = function (error, deviceName) {
                                commit("currentAudioDevice", { deviceId: undefined });
                                if (error.name === "NotAllowedError") {
                                    dispatch("setAudioDeviceError", { errorId: "NOT_ALLOWED", deviceName: deviceName });
                                    return;
                                }
                                dispatch("setAudioDeviceError", { errorId: "NOT_READABLE_DEVICE", deviceName: deviceName });
                            };
                            getAudioTrack = function () { return __awaiter(_this, void 0, void 0, function () {
                                var error_2;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            _a.trys.push([0, 2, , 3]);
                                            return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_2__device__["g" /* getAudioTrackForDevice */](audioDevice, audioProcessingDisabled)];
                                        case 1: return [2 /*return*/, _a.sent()];
                                        case 2:
                                            error_2 = _a.sent();
                                            catchAudioDeviceError(error_2, audioDevice.label);
                                            return [3 /*break*/, 3];
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); };
                            currentStream = state.streams.local;
                            if (currentStream) {
                                if (currentStream.getAudioTracks()[0]) {
                                    currentStream.getAudioTracks()[0].stop();
                                }
                            }
                            return [4 /*yield*/, getAudioTrack()];
                        case 1:
                            audioTrack = _b.sent();
                            currentStream = state.streams.local;
                            if (currentStream) {
                                if (currentStream.getAudioTracks()[0]) {
                                    currentStream.getAudioTracks()[0].stop();
                                    currentStream.removeTrack(currentStream.getAudioTracks()[0]);
                                }
                            }
                            if (audioTrack) {
                                currentStream.addTrack(audioTrack);
                            }
                            commit("localStream", currentStream);
                            dispatch("updatePeerAudioTracks");
                            return [2 /*return*/];
                    }
                });
            });
        },
        updateLocalVideoTrack: function (_a, previousDevice) {
            var commit = _a.commit, dispatch = _a.dispatch, state = _a.state;
            return __awaiter(this, void 0, void 0, function () {
                var videoDevice, isVideoDeviceScreen, catchVideoDeviceError, getVideoTrack, getScreenSharingTrack, videoTrack, currentStream;
                var _this = this;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            videoDevice = state.devices.current.video || { deviceId: undefined };
                            isVideoDeviceScreen = function () {
                                return videoDevice.deviceId === "screen";
                            };
                            catchVideoDeviceError = function (error, deviceName) {
                                commit("currentVideoDevice", { deviceId: undefined });
                                if (error.name === "NotAllowedError") {
                                    dispatch("setVideoDeviceError", { errorId: "NOT_ALLOWED", deviceName: deviceName });
                                    return;
                                }
                                dispatch("setVideoDeviceError", { errorId: "NOT_READABLE_DEVICE", deviceName: deviceName });
                            };
                            getVideoTrack = function () { return __awaiter(_this, void 0, void 0, function () {
                                var error_3;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            _a.trys.push([0, 2, , 3]);
                                            return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_2__device__["h" /* getVideoTrackForDevice */](videoDevice)];
                                        case 1: return [2 /*return*/, _a.sent()];
                                        case 2:
                                            error_3 = _a.sent();
                                            catchVideoDeviceError(error_3, videoDevice.label);
                                            return [3 /*break*/, 3];
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); };
                            getScreenSharingTrack = function () {
                                var localScreenStream = state.localScreenStream;
                                if (localScreenStream && localScreenStream.getVideoTracks()[0]) {
                                    return localScreenStream.getVideoTracks()[0];
                                }
                                return null;
                            };
                            if (!isVideoDeviceScreen()) return [3 /*break*/, 1];
                            videoTrack = getScreenSharingTrack();
                            return [3 /*break*/, 3];
                        case 1: return [4 /*yield*/, getVideoTrack()];
                        case 2:
                            videoTrack = _b.sent();
                            _b.label = 3;
                        case 3:
                            currentStream = state.streams.local;
                            if (currentStream) {
                                if (currentStream.getVideoTracks()[0]) {
                                    if (previousDevice.deviceId !== "screen") {
                                        currentStream.getVideoTracks()[0].stop();
                                    }
                                    currentStream.removeTrack(currentStream.getVideoTracks()[0]);
                                }
                            }
                            if (!videoTrack) {
                                return [2 /*return*/];
                            }
                            // Stop dummy track as we have real one now.
                            __WEBPACK_IMPORTED_MODULE_4__utils__["b" /* stopDummyVideoTrack */]();
                            currentStream.addTrack(videoTrack);
                            commit("localStream", currentStream);
                            dispatch("updatePeerVideoTracks");
                            return [2 /*return*/];
                    }
                });
            });
        },
        updatePeerAudioTracks: function (_a) {
            var state = _a.state;
            var peers = state.peers;
            var stream = state.streams.local;
            var audioProcessingDisabled = state.audioProcessingDisabled;
            peers.forEach(function (peer) {
                if (peer.isLocal)
                    return;
                __WEBPACK_IMPORTED_MODULE_3__peers__["o" /* updateAudioTransceiver */](peer, stream, audioProcessingDisabled);
            });
        },
        updatePeerVideoTracks: function (_a) {
            var state = _a.state;
            var peers = state.peers;
            var stream = state.streams.local;
            peers.forEach(function (peer) {
                if (peer.isLocal)
                    return;
                __WEBPACK_IMPORTED_MODULE_3__peers__["p" /* updateVideoTransceiver */](peer, stream);
            });
        },
        preferredVideoDevice: function (_a, deviceId) {
            var commit = _a.commit;
            commit("preferredVideoDevice", deviceId);
        },
        preferredAudioDevice: function (_a, deviceId) {
            var commit = _a.commit;
            commit("preferredAudioDevice", deviceId);
        },
        updateLocalUserName: function (_a, newName) {
            var commit = _a.commit;
            commit("localUserName", newName);
        },
        removePeer: function (_a, peer) {
            var commit = _a.commit, state = _a.state;
            var peers = state.peers;
            commit("peers", peers.filter(function (item) { return item.identifier !== peer.identifier; }));
        },
        addPeer: function (_a, peer) {
            var state = _a.state;
            var peers = state.peers;
            peers.push(peer);
        },
        clearPeers: function (_a) {
            var commit = _a.commit;
            commit("peers", []);
        },
        updateSharingScreenAndVideo: function (_a, newValue) {
            var commit = _a.commit, dispatch = _a.dispatch, state = _a.state;
            return __awaiter(this, void 0, void 0, function () {
                var stream, currentVideoDevice, peers;
                return __generator(this, function (_b) {
                    commit("sharingScreenAndVideo", newValue);
                    stream = null;
                    if (newValue) {
                        stream = state.localScreenStream;
                    }
                    currentVideoDevice = state.devices.current.video;
                    if (currentVideoDevice.deviceId === "screen" && state.sharingScreenAndVideo) {
                        dispatch("updateCurrentVideoDevice", { deviceId: undefined });
                    }
                    peers = state.peers;
                    peers.forEach(function (peer) {
                        if (peer.isLocal)
                            return;
                        __WEBPACK_IMPORTED_MODULE_3__peers__["q" /* updateScreenshareTransceiver */](peer, stream, state.sharingScreenAndVideo);
                    });
                    return [2 /*return*/];
                });
            });
        },
        bitrateLimitPeerCount: function (_a, newValue) {
            var commit = _a.commit;
            commit("bitrateLimitPeerCount", newValue);
        },
        updateVideoFlipped: function (_a, newValue) {
            var commit = _a.commit;
            commit("videoFlipped", newValue);
        },
        updateAudioProcessingDisabled: function (_a, newValue) {
            var commit = _a.commit, dispatch = _a.dispatch;
            commit("audioProcessingDisabled", newValue);
            dispatch("updateLocalAudioTrack");
        },
        updateSupportMusic: function (_a, newValue) {
            var commit = _a.commit;
            commit("supportMusic", newValue);
        },
        updateLocalAudioEnabled: function (_a, newValue) {
            var commit = _a.commit;
            commit("localAudioEnabled", newValue);
        },
        updateSupportSimultaneousScreen: function (_a, newValue) {
            var commit = _a.commit;
            commit("supportSimultaneousScreen", newValue);
        },
        updateScreenTallyActive: function (_a, newValue) {
            var commit = _a.commit;
            commit("screenTallyActive", newValue);
        }
    },
});
/* harmony default export */ __webpack_exports__["a"] = (store);


/***/ }),
/* 140 */,
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(315)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(368),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(142)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports = function (Component) { Component.options.__i18n = '{"en":{"error":{"connection":"An error that may affect your connection occured.","websocket":"Websocket error has occurred. Check your network configuration (e.g. Firewall).","session_unknown":{"header":"Unable to find the session to join","content":"Please ask your host to check the URL you were given and make sure Wirecast is connected to the session."},"session_full":{"header":"Session currently full","content":"The session is full and cannot add any more participants.  If you believe this is an error, please contact your host and request access."},"session_already_connected":{"header":"Unable to connect to the session","content":"Please ensure you are not joining the same session from the same browser."},"no_rtc":{"content":"Your browser does not support the video & audio conversations.  Please reopen using Chrome or Firefox to continue."}},"message":{"waiting":{"content":"Waiting to join the conversation..."},"welcome":{"header":"Welcome","content":"You are about to join a Wirecast Rendezvous session. Once connected, your host and any other participants will be able to see your webcam and hear your microphone. Please enter a name that will be transmitted to your host alerting them to your arrival."},"session_ended":{"content":"The session has now ended"}}},"de":{"error":{"connection":"Ein Fehler, der unter Umständen Ihre Verbindung beeinflusst, ist aufgetreten.","websocket":"Websocket-Fehler ist aufgetreten. Überprüfen Sie Ihre Netzwerkkonfiguration (z. B. Firewall).","session_unknown":{"header":"Sitzung, der beigetreten werden soll, konnte nicht gefunden werden","content":"Bitten Sie Ihren Gastgeber, die Ihnen gegebene URL zu überprüfen und sicherzustellen, dass Wirecast mit der Sitzung verbunden ist."},"session_full":{"header":"Sitzung ist momentan voll","content":"Die Sitzung ist voll und ihr können keine weiteren Teilnehmer hinzugefügt werden. Wenn Sie glauben, dass hier ein Fehler vorliegt, wenden Sie sich an den Gastgeber und fordern Sie Zugriff an."},"session_already_connected":{"header":"Verbindung zur Sitzung fehlgeschlagen","content":"Stellen Sie sicher, dass Sie der gleichen Sitzung nicht vom gleichen Browser aus beitreten."},"no_rtc":{"content":"Ihr Browser unterstützt die Video- und Audiounterhaltungen nicht. Öffnen Sie erneut in Chrome oder Firefox, um fortzufahren."}},"message":{"waiting":{"content":"Auf Beitreten zur Unterhaltung warten ..."},"welcome":{"header":"Willkommen","content":"Sie sind im Begriff, mit Wirecast einer Rendezvous-Sitzung beizutreten. Sobald eine Verbindung besteht, können Ihr Gastgeber und andere Teilnehmer durch Ihre Webcam sehen und Töne von Ihrem Mikrofon hören. Geben Sie einen Namen ein, der dem Gastgeber übermittelt wird, um ihm Ihr Erscheinen mitzuteilen."},"session_ended":{"content":"Die Sitzung ist beendet"}}}}' }

/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports = function (Component) { Component.options.__i18n = '{"en":{"content":"Your name","button_join":"Join"},"de":{"content":"Ihr Name","button_join":"Beitreten"}}' }

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports = function (Component) { Component.options.__i18n = '{"en":{"button_settings_title":"Settings","button_screen_share_title":"Share screen"},"de":{"button_settings_title":"Settings","button_screen_share_title":"Share screen"}}' }

/***/ }),
/* 145 */
/***/ (function(module, exports) {

module.exports = function (Component) { Component.options.__i18n = '{"en":{"button_settings_title":"Settings"},"de":{"button_settings_title":"Settings"}}' }

/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports = function (Component) { Component.options.__i18n = '{"en":{"button_flip_video_horizontally":"Flip Video Horizontally","button_enable_music_mode":"Enable Music Mode","button_share_screen_title":"Share Screen"},"de":{"button_flip_video_horizontally":"Video horizontal spiegeln","button_enable_music_mode":"Musikmodus aktivieren","button_share_screen_title":"Bildschirm teilen"}}' }

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports = function (Component) { Component.options.__i18n = '{"en":{"screen-share-and-camera":"Share Screen & Camera","screen-share-only":"Share Screen (Disable Camera)","stop-screen-share":"Stop Screen Share"},"de":{"screen-share-and-camera":"Share Screen & Camera","screen-share-only":"Share Screen (Disable Camera)","stop-screen-share":"Stop Screen Share"}}' }

/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports = function (Component) { Component.options.__i18n = '{"en":{"button_mute_video_title":"Mute video","button_mute_audio_title":"Mute audio","button_show_chat_title":"Show chat"},"de":{"button_mute_video_title":"Video stummschalten","button_mute_audio_title":"Audio stummschalten","button_show_chat_title":"Show chat"}}' }

/***/ }),
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 321 */,
/* 322 */,
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Participants__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Participants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Participants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ChatPanel__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ChatPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ChatPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Local__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Local___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Local__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_InfoBox__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_InfoBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_InfoBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_JoinPrompt__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_JoinPrompt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_JoinPrompt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Spinner__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Stream__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Stream___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Stream__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__screenshare__ = __webpack_require__(39);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};










// Register Spinner globally
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component("Spinner", __WEBPACK_IMPORTED_MODULE_7__components_Spinner___default.a);
/* harmony default export */ __webpack_exports__["default"] = ({
    name: "app",
    components: {
        InfoBox: __WEBPACK_IMPORTED_MODULE_5__components_InfoBox___default.a,
        JoinPrompt: __WEBPACK_IMPORTED_MODULE_6__components_JoinPrompt___default.a,
        Participants: __WEBPACK_IMPORTED_MODULE_2__components_Participants___default.a,
        ChatPanel: __WEBPACK_IMPORTED_MODULE_3__components_ChatPanel___default.a,
        Local: __WEBPACK_IMPORTED_MODULE_4__components_Local___default.a,
        Stream: __WEBPACK_IMPORTED_MODULE_8__components_Stream___default.a,
    },
    watch: {
        locale: function (val) {
            this.$i18n.locale = val;
        },
    },
    computed: __assign(__assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(["chatFeatureEnabled", "sharingScreenAndVideo", "sharingScreenOnly", "screenTallyActive"])), { isError: function () {
            return !!this.$store.getters.fatalError;
        },
        isPure: function () {
            return !this.isError && this.$store.getters.appState === "pure";
        },
        isConnected: function () {
            return !this.isError && this.$store.getters.appState === "connected";
        },
        isJoining: function () {
            return !this.isError && this.$store.getters.appState === "joining";
        },
        isDisconnected: function () {
            return !this.isError && this.$store.getters.appState === "disconnected";
        },
        isIOS: function () {
            return !this.isError && this.$store.getters.appState === "ios";
        },
        /* Environment error predicates */
        isErrorNoRTC: function () {
            return this.isError && this.$store.getters.fatalError === "NO_RTC";
        },
        /* Session error predicates */
        isSessionUnknown: function () {
            return this.$store.getters.fatalError === "SESSION_UNKNOWN";
        },
        isSessionFull: function () {
            return this.$store.getters.fatalError === "SESSION_FULL";
        },
        isSessionAlreadyConnected: function () {
            return this.$store.getters.fatalError === "SESSION_ALREADYCONNECTED";
        },
        /* Minor Error */
        minorError: function () {
            return this.$store.getters.minorError;
        },
        deviceError: function () {
            return this.$store.getters.deviceError;
        },
        audioDeviceError: function () {
            return this.$store.getters.audioDeviceError;
        },
        videoDeviceError: function () {
            return this.$store.getters.videoDeviceError;
        },
        screenShareError: function () {
            return this.$store.getters.screenShareError;
        },
        /* Show chat */
        chatEnabled: function () {
            return this.isConnected && this.chatFeatureEnabled;
        } }),
    methods: {
        onMinorErrorDismiss: function () {
            this.$store.dispatch("setMinorError", false);
        },
        onShareScreenErrorDismiss: function () {
            this.$store.dispatch("setScreenShareError", null);
        },
        enableScreenshareOnly: function () {
            __WEBPACK_IMPORTED_MODULE_9__screenshare__["a" /* enableScreenOnly */](this.$store, this.$socket);
        },
        disableScreenshareOnly: function () {
            __WEBPACK_IMPORTED_MODULE_9__screenshare__["b" /* stopScreen */](this.$store, this.$socket);
        },
    },
    created: function () {
        if (/iphone|ipad/i.test(navigator.userAgent)) {
            this.$store.dispatch("updateAppState", "ios");
            return;
        }
        if (!window.RTCPeerConnection) {
            this.$store.dispatch("setFatalError", "NO_RTC");
        }
    },
});


/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__device__ = __webpack_require__(67);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


/* harmony default export */ __webpack_exports__["default"] = ({
    name: "audio_device_select",
    data: function () {
        return {
            selectedDevice: {},
            unsubscribe: null,
        };
    },
    computed: __assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])(["currentAudioDevice", "audioDevices"])),
    methods: {
        onChange: function () {
            // Clear previous device errors
            this.$store.dispatch("setAudioDeviceError", { errorId: undefined, deviceName: undefined });
            var device = __WEBPACK_IMPORTED_MODULE_1__device__["a" /* findDeviceById */](this.selectedDevice, this.audioDevices);
            if (!device) {
                this.$store.dispatch("updateCurrentAudioDevice", { deviceId: undefined });
                return;
            }
            this.$store.dispatch("updateCurrentAudioDevice", device);
        },
    },
    beforeMount: function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.currentAudioDevice) {
                    this.selectedDevice = this.currentAudioDevice.deviceId;
                }
                this.unsubscribe = this.$store.subscribe(function (_a) {
                    var type = _a.type;
                    if (type === "currentAudioDevice") {
                        if (_this.currentAudioDevice && _this.currentAudioDevice.deviceId === undefined) {
                            _this.selectedDevice = undefined;
                            return;
                        }
                    }
                    if (type !== "audioDevices")
                        return;
                    if (!_this.currentAudioDevice) {
                        // It is a first time audio devices are loaded. Try to pick preferred device.
                        var preferredDevice = __WEBPACK_IMPORTED_MODULE_1__device__["b" /* getPreferredDevices */]().audioDeviceId;
                        _this.selectedDevice = __WEBPACK_IMPORTED_MODULE_1__device__["c" /* getDefaultFromList */](preferredDevice, _this.$store.getters.audioDevices, _this.$store);
                        _this.onChange();
                        return;
                    }
                    var selectedPresent = _this.audioDevices.find(function (_a) {
                        var deviceId = _a.deviceId;
                        return deviceId === _this.selectedDevice;
                    });
                    // Currently selected device is present, so no need to continue.
                    // For Chrome device may change but deviceId is still the same (default, communications).
                    // Call onChange in such case.
                    if (selectedPresent && _this.selectedDevice !== "default" && _this.selectedDevice !== "communications")
                        return;
                    if (_this.selectedDevice === "default" || _this.selectedDevice === "communications") {
                        _this.onChange();
                        return;
                    }
                    _this.selectedDevice = undefined;
                    _this.$store.dispatch("updateCurrentAudioDevice", { deviceId: undefined });
                });
                return [2 /*return*/];
            });
        });
    },
    destroyed: function () {
        if (typeof this.unsubscribe === "function") {
            this.unsubscribe();
        }
    },
});


/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chat_Message__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chat_Message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__chat_Message__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};



/* harmony default export */ __webpack_exports__["default"] = ({
    name: "ChatPanel",
    components: {
        Message: __WEBPACK_IMPORTED_MODULE_2__chat_Message___default.a,
    },
    data: function () {
        return {
            message: "",
            messageTextareaFocus: false,
        };
    },
    computed: __assign(__assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])(["showChat", "chatMessages"])), { noMessages: function () {
            return this.chatMessages.length === 0;
        } }),
    methods: __assign(__assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapMutations */])(["setChatPanelOpened"])), { sendMessage: function (event) {
            if (event.shiftKey) {
                return;
            }
            var trimmedMessage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["trim"])(this.message);
            if (trimmedMessage == "")
                return;
            this.$socket.sendWithoutSession("sendChatMessage", {
                content: trimmedMessage,
            });
            this.message = "";
            this.autoResize();
        },
        closeChatPanel: function () {
            this.setChatPanelOpened(false);
        },
        scrollToLastMessage: function () {
            var container = this.$refs["chat-content"];
            container.scrollTop = container.scrollHeight;
        },
        autoResize: function (event) {
            var _this = this;
            var messageTextarea = this.$refs["chat-message"];
            setTimeout(function () {
                messageTextarea.style.cssText = "height:auto; padding:0";
                var height = messageTextarea.scrollHeight;
                if (height > 48)
                    height = 48;
                if (event === undefined || event.shiftKey || event.keyCode !== 13) {
                    messageTextarea.style.cssText = "height:" + height + "px";
                }
                _this.scrollToLastMessage();
            });
        } }),
    watch: {
        chatMessages: function () {
            setTimeout(this.scrollToLastMessage, 0);
        },
        showChat: function (newValue) {
            if (newValue)
                setTimeout(this.scrollToLastMessage, 0);
        },
    },
    mounted: function () {
        this.scrollToLastMessage();
    },
});


/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    name: "infoBox",
    data: function () {
        return {};
    },
}));


/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__communication__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MyStream_vue__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MyStream_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MyStream_vue__);


/* harmony default export */ __webpack_exports__["default"] = ({
    name: "joinPrompt",
    components: {
        MyStream: __WEBPACK_IMPORTED_MODULE_1__MyStream_vue___default.a,
    },
    data: function () {
        return {
            name: "",
        };
    },
    computed: {
        isButtonDisabled: function () {
            return !this.name || !this.$store.getters.localStream;
        },
    },
    watch: {
        locale: function (val) {
            this.$i18n.locale = val;
        },
    },
    methods: {
        onInput: function () {
            var defaultName = this.$store.getters.defaultLocalUserName;
            this.$store.dispatch("updateLocalUserName", this.name || defaultName);
        },
        onSubmit: function () {
            var _this = this;
            this.$store.dispatch("updateAppState", "joining");
            this.$socket.on("joinPeerResponse", function (payload) {
                if (payload.result !== "OK") {
                    _this.$store.dispatch("setFatalError", payload.result);
                    return;
                }
                _this.$store.dispatch("setFatalError", undefined);
            });
            __WEBPACK_IMPORTED_MODULE_0__communication__["a" /* establish */](this.$socket, this.$store);
            this.$socket.open(this.name);
        },
    },
});


/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Stream__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Stream___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Stream__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VideoDeviceSelect__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VideoDeviceSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__VideoDeviceSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AudioDeviceSelect__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AudioDeviceSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AudioDeviceSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OptionsMenuSelect__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OptionsMenuSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__OptionsMenuSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ScreenMenuSelect__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ScreenMenuSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ScreenMenuSelect__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};






/* harmony default export */ __webpack_exports__["default"] = ({
    name: "local",
    components: {
        Stream: __WEBPACK_IMPORTED_MODULE_1__Stream___default.a,
        VideoDeviceSelect: __WEBPACK_IMPORTED_MODULE_2__VideoDeviceSelect___default.a,
        AudioDeviceSelect: __WEBPACK_IMPORTED_MODULE_3__AudioDeviceSelect___default.a,
        OptionsMenuSelect: __WEBPACK_IMPORTED_MODULE_4__OptionsMenuSelect___default.a,
        ScreenMenuSelect: __WEBPACK_IMPORTED_MODULE_5__ScreenMenuSelect___default.a,
    },
    data: function () {
        return {
            localPeerId: "",
            dropdownVisible: false,
            screenDropdownVisible: false,
        };
    },
    computed: __assign(__assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])(["supportScreensharing", "sharingScreenAndVideo", "sharingScreenOnly"])), { sourceStream: function () {
            return this.$store.getters.localStream;
        },
        isError: function () {
            return !!this.$store.getters.fatalError;
        },
        isConnected: function () {
            return !this.isError && this.$store.getters.appState === "connected";
        } }),
    methods: {
        toggleDropdown: function () {
            this.dropdownVisible = !this.dropdownVisible;
        },
        toggleScreenDropdown: function () {
            this.screenDropdownVisible = !this.screenDropdownVisible;
        },
    },
    created: function () {
        var _this = this;
        this.$socket.whenReady().then(function (_a) {
            var session = _a.session;
            _this.localPeerId = session.peerGuid;
        });
        document.addEventListener("click", function (event) {
            if (event.target.matches("[data-settings-dropdown]"))
                return;
            _this.dropdownVisible = false;
        });
        document.addEventListener("click", function (event) {
            if (event.target.matches("[data-screen-dropdown]"))
                return;
            _this.screenDropdownVisible = false;
        });
    },
});


/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stream__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stream___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Stream__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VideoDeviceSelect__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VideoDeviceSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__VideoDeviceSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AudioDeviceSelect__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AudioDeviceSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AudioDeviceSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OptionsMenuSelect__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OptionsMenuSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__OptionsMenuSelect__);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




/* harmony default export */ __webpack_exports__["default"] = ({
    name: "local",
    components: {
        Stream: __WEBPACK_IMPORTED_MODULE_0__Stream___default.a,
        VideoDeviceSelect: __WEBPACK_IMPORTED_MODULE_1__VideoDeviceSelect___default.a,
        AudioDeviceSelect: __WEBPACK_IMPORTED_MODULE_2__AudioDeviceSelect___default.a,
        OptionsMenuSelect: __WEBPACK_IMPORTED_MODULE_3__OptionsMenuSelect___default.a,
    },
    data: function () {
        return {
            localPeerId: "",
            dropdownVisible: false,
        };
    },
    computed: {
        sourceStream: function () {
            return this.$store.getters.localStream;
        },
    },
    methods: {
        toggleDropdown: function () {
            this.dropdownVisible = !this.dropdownVisible;
        },
    },
    mounted: function () {
        this.$nextTick(function () {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.$store.dispatch("loadInputDevices")
                            // Listen for device changes only after first initialization          
                        ];
                        case 1:
                            _a.sent();
                            // Listen for device changes only after first initialization          
                            navigator.mediaDevices.addEventListener("devicechange", function () {
                                _this.$store.dispatch("loadInputDevices");
                            });
                            return [2 /*return*/];
                    }
                });
            });
        });
    },
    created: function () {
        var _this = this;
        this.$socket.whenReady().then(function (_a) {
            var session = _a.session;
            _this.localPeerId = session.peerGuid;
        });
        document.addEventListener("click", function (event) {
            if (event.target.matches("[data-settings-dropdown]"))
                return;
            _this.dropdownVisible = false;
        });
    },
});


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(6);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "options_menu_select",
    props: ["initialMode"],
    watch: {
        sharingScreenAndVideo: function (allowed) {
            this.sharingScreenAndVideo = allowed;
        }
    },
    computed: __assign(__assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])(["supportMusic", "sharingScreenAndVideo", "sharingScreenOnly"])), { videoFlipped: {
            get: function () {
                return this.$store.getters.videoFlipped;
            },
            set: function (val) {
                this.$store.dispatch("updateVideoFlipped", val);
            }
        }, audioProcessingDisabled: {
            get: function () {
                return this.$store.getters.audioProcessingDisabled;
            },
            set: function (val) {
                this.$store.dispatch("updateAudioProcessingDisabled", val);
            }
        } }),
    methods: {
        getScreenShareStream: function () {
            return __awaiter(this, void 0, void 0, function () {
                var stream, err_1;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 3, , 4]);
                            stream = this.$store.getters.localScreenStream;
                            if (!!stream) return [3 /*break*/, 2];
                            return [4 /*yield*/, window.navigator.mediaDevices.getDisplayMedia({
                                    video: {
                                        cursor: "always",
                                    },
                                    audio: false,
                                })];
                        case 1:
                            stream = _a.sent();
                            this.$store.dispatch("setLocalScreenStream", stream);
                            _a.label = 2;
                        case 2:
                            stream.getVideoTracks()[0].addEventListener("ended", function () {
                                // The sharing was ended e.g. by clicking the chrome "Stop Sharing" button.
                                _this.$socket.sendWithoutSession("updateSharingState", {
                                    enabled: false,
                                });
                                _this.$store.dispatch("updateSharingScreenAndVideo", false);
                                _this.$store.dispatch("setLocalScreenStream", null);
                            });
                            this.$store.dispatch("setScreenShareError", null);
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            this.$store.dispatch("setScreenShareError", err_1.message);
                            this.$store.dispatch("setLocalScreenStream", null);
                            this.$store.dispatch("updateSharingScreenAndVideo", false);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
        onScreenSharingChange: function (_a) {
            var target = _a.target;
            return __awaiter(this, void 0, void 0, function () {
                var enabled;
                var _this = this;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            enabled = target.checked;
                            if (!enabled) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.getScreenShareStream()];
                        case 1:
                            _b.sent();
                            if (!this.$store.getters.localScreenStream) {
                                return [2 /*return*/];
                            }
                            _b.label = 2;
                        case 2:
                            this.$socket.sendWithoutSession("updateSharingState", {
                                enabled: enabled,
                            });
                            if (!enabled) {
                                setTimeout(function () {
                                    _this.$store.dispatch("updateSharingScreenAndVideo", enabled);
                                });
                            }
                            return [2 /*return*/];
                    }
                });
            });
        },
    }
});


/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stream__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stream___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Stream__);

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "participants",
    components: {
        Stream: __WEBPACK_IMPORTED_MODULE_0__Stream___default.a,
    },
    data: function () {
        return {
            layoutModified: false,
            expandedStream: "",
        };
    },
    watch: {
        peers: function (peers) {
            var _this = this;
            peers.forEach(function (peer) {
                if (peer.screenSource) {
                    _this.expandedStream = peer.identifier;
                }
            });
            if (this.expandedStream || this.layoutModified)
                return;
            this.expandedStream = peers[0].identifier;
        },
    },
    computed: {
        peers: function () {
            return this.$store.getters.peers.filter(function (peer) { return !peer.isLocal; });
        },
        isAnyStreamExpanded: function () {
            return !!this.expandedStream;
        },
    },
    methods: {
        expandStream: function (id) {
            this.layoutModified = true;
            if (this.expandedStream === id && this.peers.length > 1) {
                this.expandedStream = "";
                return;
            }
            this.expandedStream = id;
        },
        videoDisplayClass: function (id) {
            if (this.expandedStream === id)
                return "expanded-video";
            return "minature-video";
        },
    },
});


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__screenshare__ = __webpack_require__(39);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


/* harmony default export */ __webpack_exports__["default"] = ({
    name: "screen_menu_select",
    data: function () {
        return {
            selectedOption: undefined
        };
    },
    computed: __assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])(["sharingScreenAndVideo", "supportSimultaneousScreen", "sharingScreenOnly"])),
    watch: {
        sharingScreenAndVideo: function (enabled) {
            if (enabled) {
                this.selectedOption = "screen-camera";
            }
            else {
                if (!this.sharingScreenOnly) {
                    this.selectedOption = undefined;
                }
            }
        },
        sharingScreenOnly: function (enabled) {
            if (enabled) {
                this.selectedOption = "screen-only";
            }
            else {
                if (!this.sharingScreenAndVideo) {
                    this.selectedOption = undefined;
                }
            }
        },
    },
    methods: {
        onChange: function (event) {
            var _this = this;
            this.selectedOption = undefined;
            setTimeout(function () {
                switch (event.target.value) {
                    case "screen-camera":
                        __WEBPACK_IMPORTED_MODULE_1__screenshare__["c" /* enableScreenAndVideo */](_this.$store, _this.$socket);
                        break;
                    case "screen-only":
                        __WEBPACK_IMPORTED_MODULE_1__screenshare__["a" /* enableScreenOnly */](_this.$store, _this.$socket);
                        break;
                    default:
                        __WEBPACK_IMPORTED_MODULE_1__screenshare__["b" /* stopScreen */](_this.$store, _this.$socket);
                }
            }, 0);
        },
    }
});


/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
    props: ["isVisible"],
    data: function () {
        return {};
    },
});


/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_search_params__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_search_params___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_search_params__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__screenshare__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__log__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_webrtc_adapter__ = __webpack_require__(69);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};





var VideoOriginal = "video[data-original]";
var VideoScreen = "video[data-screen]";
var log = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__log__["a" /* default */])("stream");
function toggleTrack(tracksGetter) {
    var track = tracksGetter()[0];
    if (!track) {
        console.error("No track found", tracksGetter);
        return;
    }
    return (track.enabled = !track.enabled);
}
// label argument is for debug only
function setVideoElementSource($el, source, isLocal, label) {
    var videoElement = $el.querySelector(VideoOriginal);
    if (isLocal) {
        videoElement.muted = true;
        videoElement.onloadedmetadata = function () {
            log("Local resolution: " + videoElement.videoWidth + "x" + videoElement.videoHeight);
        };
    }
    if (videoElement.srcObject && source && videoElement.srcObject.id === source.id) {
        return;
    }
    log("Setting new stream for", label, ":", source.id);
    videoElement.srcObject = source;
}
function setVideoElementScreenSource($el, screenSource, isLocal, label) {
    var videoElement = $el.querySelector(VideoScreen);
    if (isLocal) {
        videoElement.muted = true;
        videoElement.onloadedmetadata = function () {
            log("Local resolution: " + videoElement.videoWidth + "x" + videoElement.videoHeight);
        };
    }
    if (videoElement.srcObject && screenSource && videoElement.srcObject.id === screenSource.id) {
        return;
    }
    log("Setting new stream for", label, ":", screenSource.id);
    videoElement.srcObject = screenSource;
}
function lockElementHeight(videoElement) {
    var firstVideoElement = document.querySelector("[container] " + VideoOriginal);
    if (firstVideoElement && firstVideoElement !== videoElement) {
        var height = firstVideoElement.offsetHeight;
        //videoElement.setAttribute('style', `height: ${height}px`);
    }
}
function freeElementHeight(videoElement) {
    videoElement.removeAttribute("style");
}
function attachCanPlayEvent() {
    var _this = this;
    var videoElement = this.$el.querySelector(VideoOriginal);
    lockElementHeight(videoElement);
    var onCanPlay = function () {
        freeElementHeight(videoElement);
        _this.isVideoReady = true;
        videoElement.removeEventListener("canplay", onCanPlay);
    };
    videoElement.addEventListener("canplay", onCanPlay);
}
/* harmony default export */ __webpack_exports__["default"] = ({
    name: "stream",
    props: ["source", "screenSource", "label", "isLocalStream", "id", "peer", "localInitialMode"],
    watch: {
        source: {
            handler: function (currentStream) {
                if (!currentStream) {
                    console.error("Stream empty for " + this.userName);
                    return;
                }
                setVideoElementSource(this.$el, currentStream, this.isLocalStream, this.userName);
            },
        },
        localStreamUpdated: {
            handler: function (updated) {
                if (!updated || !this.source)
                    return;
                var videoTrack = this.source.getVideoTracks()[0];
                if (videoTrack) {
                    videoTrack.enabled = this.videoEnabled;
                }
                var audioTrack = this.source.getAudioTracks()[0];
                if (audioTrack) {
                    audioTrack.enabled = this.audioEnabled;
                }
                this.$store.commit("localStreamUpdated", false);
            }
        },
        screenSource: {
            handler: function (screenStream) {
                if (!screenStream)
                    return;
                setVideoElementScreenSource(this.$el, screenStream, this.isLocalStream, this.userName);
            }
        },
        locale: function (val) {
            this.$i18n.locale = val;
        },
    },
    data: function () {
        return {
            isLive: false,
            isAudioMuted: false,
            isVideoReady: false,
            videoEnabled: true,
            remoteAudioEnabled: true,
            showBitrate: false,
            bitrate: 0,
            isChrome: __WEBPACK_IMPORTED_MODULE_4_webrtc_adapter__["a" /* default */].browserDetails.browser === "chrome",
        };
    },
    computed: __assign(__assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])(["chatFeatureEnabled", "showNewMessageIndicator", "localStreamUpdated", "sharingScreenOnly", "supportSimultaneousScreen"])), { streamClass: function () {
            if (this.localInitialMode) {
                return "local-initial";
            }
            return this.isLocalStream ? "local" : "remote";
        },
        userName: function () {
            if (this.isLocalStream)
                return this.$store.getters.localUserName;
            return this.label;
        },
        isSuspended: function () {
            if (this.isLocalStream)
                return false;
            return this.peer.isSuspended;
        },
        isTallyActive: function () {
            if (this.$store.getters.appState !== "connected")
                return false;
            if (!this.isLocalStream)
                return false;
            return this.isLive;
        },
        isScreenShare: function () {
            if (this.screenSource)
                return true;
            return false;
        },
        isRemoteAudioMuted: function () {
            if (this.$store.getters.appState !== "connected")
                return false;
            if (this.isLocalStream)
                return false;
            return this.isAudioMuted;
        },
        showChatIcon: function () {
            return this.localInitialMode !== true && this.isLocalStream && this.chatFeatureEnabled;
        },
        videoFlipped: function () {
            return this.$store.getters.videoFlipped;
        }, audioEnabled: {
            get: function () {
                if (this.isLocalStream) {
                    return this.$store.getters.localAudioEnabled;
                }
                return this.remoteAudioEnabled;
            },
            set: function (val) {
                if (this.isLocalStream) {
                    this.$store.dispatch("updateLocalAudioEnabled", val);
                }
                else {
                    this.remoteAudioEnabled = val;
                }
            }
        } }),
    methods: __assign(__assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])(["toggleChatPanelOpened"])), { toggleVideo: function () {
            if (this.isLocalStream && this.sharingScreenOnly) {
                // This is for backward compatibility with WC < 15.1
                if (this.supportSimultaneousScreen) {
                    __WEBPACK_IMPORTED_MODULE_2__screenshare__["c" /* enableScreenAndVideo */](this.$store, this.$socket);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_2__screenshare__["b" /* stopScreen */](this.$store, this.$socket);
                }
                return;
            }
            if (!this.source)
                return;
            this.videoEnabled = toggleTrack(this.source.getVideoTracks.bind(this.source));
        },
        toggleAudio: function () {
            if (!this.source)
                return;
            this.audioEnabled = toggleTrack(this.source.getAudioTracks.bind(this.source));
            if (this.$store.getters.appState !== "connected")
                return false;
            if (!this.isLocalStream)
                return false;
            var messageJson = {
                subaction: "audioMuteStateChanged",
                value: !this.audioEnabled
            };
            this.$socket.send("broadcastToPeers", messageJson);
        } }),
    mounted: function () {
        var _this = this;
        var params = __WEBPACK_IMPORTED_MODULE_1_search_params__["parse"](window.location.search.replace(/^\?/, ""));
        var bitrate = params.find(function (param) { return param.name === "show_bitrate"; });
        if (!this.isLocalStream && bitrate) {
            this.showBitrate = true;
            this.peer.onBitrateChange = function (bitrate) {
                _this.bitrate = bitrate;
            };
        }
        // Tally and audio mute update
        this.$socket.on("gotBroadcastToAll", function (payload) {
            if (payload.subaction === "tallyStateChanged") {
                if (payload.tallyPeerIdentifier !== _this.id)
                    return;
                _this.isLive = payload.value;
            }
            else if (payload.subaction === "screenTallyStateChanged") {
                if (payload.peersIdentifier !== _this.id)
                    return;
                _this.$store.dispatch("updateScreenTallyActive", payload.value);
            }
            else if (payload.subaction === "audioMuteStateChanged") {
                if (payload.peersIdentifier !== _this.id)
                    return;
                _this.isAudioMuted = payload.value;
            }
        });
        this.$socket.on("gotDirectMessage", function (payload) {
            if (payload.subaction === "tallyStateChanged") {
                if (payload.tallyPeerIdentifier !== _this.id)
                    return;
                _this.isLive = payload.value;
            }
            else if (payload.subaction === "screenTallyStateChanged") {
                if (payload.peersIdentifier !== _this.id)
                    return;
                _this.$store.dispatch("updateScreenTallyActive", payload.value);
            }
            else if (payload.subaction === "audioMuteStateChanged") {
                if (payload.peersIdentifier !== _this.id)
                    return;
                _this.isAudioMuted = payload.value;
            }
        });
        attachCanPlayEvent.call(this);
        if (!this.source) {
            return;
        }
        var audioTrack = this.source.getAudioTracks()[0];
        if (audioTrack) {
            this.audioEnabled = audioTrack.enabled;
        }
        var videoTrack = this.source.getVideoTracks()[0];
        if (videoTrack) {
            this.videoEnabled = videoTrack.enabled;
        }
        setVideoElementSource(this.$el, this.source, this.isLocalStream, this.userName);
    },
});


/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__device__ = __webpack_require__(67);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


/* harmony default export */ __webpack_exports__["default"] = ({
    name: "video_device_select",
    data: function () {
        var self = this;
        return {
            selectedDevice: {},
            unsubscribe: null,
        };
    },
    computed: __assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])(["currentVideoDevice", "videoDevices", "sharingScreenOnly"])),
    methods: {
        onChange: function () {
            // Clear previous device and screen errors
            this.$store.dispatch("setVideoDeviceError", { errorId: undefined, deviceName: undefined });
            this.$store.dispatch("setScreenShareError", undefined);
            var device = __WEBPACK_IMPORTED_MODULE_1__device__["a" /* findDeviceById */](this.selectedDevice, this.videoDevices);
            if (!device) {
                this.$store.dispatch("updateCurrentVideoDevice", { deviceId: undefined });
                return;
            }
            this.$store.dispatch("updateCurrentVideoDevice", device);
        },
    },
    beforeMount: function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.currentVideoDevice) {
                    this.selectedDevice = this.currentVideoDevice.deviceId;
                }
                // Update device list and stream when current device is
                // removed
                this.unsubscribe = this.$store.subscribe(function (_a) {
                    var type = _a.type;
                    if (type === "currentVideoDevice") {
                        if (_this.currentVideoDevice && (_this.currentVideoDevice.deviceId === undefined
                            || _this.currentVideoDevice.deviceId === "screen")) {
                            _this.selectedDevice = undefined;
                            return;
                        }
                    }
                    if (type !== "videoDevices")
                        return;
                    if (!_this.currentVideoDevice) {
                        // It is a first time video devices are loaded. Try to pick preferred device.
                        var preferredDevice = __WEBPACK_IMPORTED_MODULE_1__device__["b" /* getPreferredDevices */]().videoDeviceId;
                        _this.selectedDevice = __WEBPACK_IMPORTED_MODULE_1__device__["c" /* getDefaultFromList */](preferredDevice, _this.videoDevices, _this.$store);
                        _this.onChange();
                        return;
                    }
                    var selectedPresent = _this.videoDevices.find(function (_a) {
                        var deviceId = _a.deviceId;
                        return deviceId === _this.selectedDevice;
                    });
                    // Currently selected device is present, so no need to continue
                    if (selectedPresent)
                        return;
                    _this.selectedDevice = undefined;
                    _this.$store.dispatch("updateCurrentVideoDevice", { deviceId: undefined });
                });
                return [2 /*return*/];
            });
        });
    },
    destroyed: function () {
        if (typeof this.unsubscribe === "function") {
            this.unsubscribe();
        }
    },
});


/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_autolinker__ = __webpack_require__(150);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};



/* harmony default export */ __webpack_exports__["default"] = ({
    name: "Message",
    props: ["message"],
    computed: __assign(__assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])(["localChatPeerId", "getPeerColor"])), { username: function () {
            if (this.isLocal)
                return "You";
            if (this.isMaster)
                return "Host";
            return this.message.username;
        },
        content: function () {
            return this.message.content || "";
        },
        linkedContent: function () {
            return __WEBPACK_IMPORTED_MODULE_2_autolinker__["a" /* default */].link(this.content, {
                className: "chat-message-url",
                sanitizeHtml: true,
                stripPrefix: false,
            });
        },
        time: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_date_fns__["a" /* format */])(new Date(this.message.time), "H:mm");
        },
        peerId: function () {
            return this.message.peersIdentifier;
        },
        messageIndex: function () {
            return this.message.index;
        },
        isLocal: function () {
            return this.peerId === this.localChatPeerId;
        },
        isMaster: function () {
            return this.message.master;
        },
        isDeleted: function () {
            return this.message.deleted;
        },
        canBeDeleted: function () {
            return this.isLocal && !this.isDeleted;
        },
        messageBubbleColor: function () {
            if (this.isMaster)
                return "#161616";
            return this.getPeerColor(this.peerId);
        },
        chatBubbleCssClass: function () {
            var bubbleClass = ["chat-bubble"];
            if (this.isMaster)
                bubbleClass.push("chat-bubble-master");
            if (this.isLocal)
                bubbleClass.push("chat-bubble-me");
            if (this.isDeleted)
                bubbleClass.push("chat-bubble-deleted");
            return bubbleClass.join(" ");
        } }),
    methods: {
        deleteMessage: function () {
            this.$socket.sendWithoutSession("deleteChatMessage", {
                index: this.messageIndex,
            });
        },
    },
});


/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setMediaBitrate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_search_params__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_search_params___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_search_params__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__peers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__log__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_webrtc_adapter__ = __webpack_require__(69);




var log = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__log__["a" /* default */])("bandwidth");
function isFirefox() {
    return __WEBPACK_IMPORTED_MODULE_3_webrtc_adapter__["a" /* default */].browserDetails.browser === "firefox";
}
function getBitrate() {
    var params = __WEBPACK_IMPORTED_MODULE_0_search_params__["parse"](window.location.search.replace(/^\?/, ""));
    var bandwidth = params.find(function (param) { return param.name === "bandwidth"; });
    if (bandwidth && bandwidth.value) {
        log("Will use bandwidth:", +bandwidth.value);
        return +bandwidth.value;
    }
}
function getBitrateByPeersCount() {
    var peersCount = Array.from(__WEBPACK_IMPORTED_MODULE_1__peers__["l" /* getAll */]().keys()).length;
    var limit = [
        undefined,
        undefined,
        undefined,
        384,
        256,
        192,
        128,
        128,
        64,
    ][peersCount];
    return limit;
}
function setMediaBitrate(sdp, media) {
    var lines = sdp.split("\n");
    var line = -1;
    var bitrateWanted = getBitrate() || getBitrateByPeersCount();
    if (!bitrateWanted) {
        log("No bandwidth limit");
        return sdp;
    }
    else {
        log("Limiting bandwidth to", bitrateWanted);
    }
    var lineType = isFirefox() ? "b=TIAS:" : "b=AS:";
    var bitrate = isFirefox() ? bitrateWanted * 1000 : bitrateWanted;
    for (var i = 0; i < lines.length; i++) {
        if (lines[i].indexOf("m=" + media) === 0) {
            line = i;
            break;
        }
    }
    if (line === -1) {
        console.debug("Could not find the m line for", media);
        return sdp;
    }
    console.debug("Found the m line for", media, "at line", line);
    // Pass the m line
    line++;
    // Skip i and c lines
    while (lines[line].indexOf("i=") === 0 || lines[line].indexOf("c=") === 0) {
        line++;
    }
    // If we're on a b line, replace it
    if (lines[line].indexOf("b") === 0) {
        console.debug("Replaced b line at line", line);
        lines[line] = lineType + bitrate;
        return lines.join("\n");
    }
    // Add a new b line
    console.debug("Adding new b line before line", line);
    var newLines = lines.slice(0, line);
    newLines.push(lineType + bitrate);
    newLines = newLines.concat(lines.slice(line, lines.length));
    return newLines.join("\n");
}


/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = establish;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__peers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__session__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__log__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_webrtc_adapter__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__screenshare__ = __webpack_require__(39);
/**
 * Protocol logic implementation
 * @module Communication
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};





var log = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__log__["a" /* default */])("communication");
function catchConnectionError($store, fn) {
    return __awaiter(this, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fn()];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    $store.dispatch("setMinorError", "CONNECTION");
                    console.error("Connection error");
                    console.error(e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function onPeerConnectionClosed(_a) {
    var peer = _a.peer;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            log("onPeerConnectionClosed", peer.name);
            return [2 /*return*/];
        });
    });
}
function onPeerConnectionDisconnected(_a) {
    var peer = _a.peer;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            log("onPeerConnectionDisconnected", peer.name, "suspended?", peer.isSuspended);
            peer.isSuspended = true;
            return [2 /*return*/];
        });
    });
}
function onPeerConnectionConnected(_a) {
    var _this = this;
    var $store = _a.$store, peer = _a.peer, session = _a.session;
    log("onPeerConnectionConnected", peer.name);
    peer.isSuspended = false;
    var messageJson = {
        identifier: peer.identifier,
        subaction: "audioMuteStateChanged",
        value: !$store.getters.localAudioEnabled
    };
    __WEBPACK_IMPORTED_MODULE_1__session__["a" /* send */](session, "directMessage", messageJson);
    setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
        var stats, candidatePair, localIP, remoteIP, turnIPs;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, peer.connection.getStats(null)];
                case 1:
                    stats = _a.sent();
                    candidatePair = Array.from(stats.values()).find(function (report) {
                        return report.type == "candidate-pair" && report.state == "succeeded" && report.nominated == true;
                    });
                    if (!candidatePair) {
                        log("Undefined candidates");
                        return [2 /*return*/];
                    }
                    localIP = "";
                    remoteIP = "";
                    stats.forEach(function (report) {
                        switch (report.id) {
                            case candidatePair.localCandidateId:
                                localIP = "ipAddress" in report ? report.ipAddress : report.ip;
                                break;
                            case candidatePair.remoteCandidateId:
                                remoteIP = "ipAddress" in report ? report.ipAddress : report.ip;
                                break;
                        }
                    });
                    log("WebRTC connection local_ip: ", localIP, "remote_ip: ", remoteIP);
                    if (!localIP || !remoteIP)
                        return [2 /*return*/];
                    turnIPs = session.iceServers
                        .map(function (iceServer) {
                        if (iceServer.urls.length == 0)
                            return null;
                        var match = /turn:(\d+\.\d+\.\d+\.\d+)/.exec(iceServer.urls[0]);
                        return match === null ? null : match[1];
                    })
                        .filter(function (ip) { return ip != null; });
                    peer.localConnectionType = turnIPs.includes(localIP) ? "turn" : "non-turn";
                    peer.remoteConnectionType = turnIPs.includes(remoteIP) ? "turn" : "non-turn";
                    __WEBPACK_IMPORTED_MODULE_1__session__["a" /* send */](session, "reportConnection", {
                        reconnectCount: peer.reconnectCount++,
                        localType: peer.localConnectionType,
                        remoteType: peer.remoteConnectionType,
                    });
                    return [2 /*return*/];
            }
        });
    }); }, 0);
}
function onPeerConnectionFailed(_a) {
    var $store = _a.$store, peer = _a.peer, session = _a.session;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            log("FAILED connection for", peer.name, peer);
            log("Trying to restart ICE for", peer.name);
            peer.isSuspended = true;
            peer.connection.restartIce();
            return [2 /*return*/];
        });
    });
}
function createPeer($store, session, payload, reconnectCount, suspended) {
    var _this = this;
    if (reconnectCount === void 0) { reconnectCount = 0; }
    if (suspended === void 0) { suspended = false; }
    var peersIdentifier = payload.peersIdentifier, username = payload.username, master = payload.master;
    // Remove and close old master peer when reconnecting Wirecast
    if (master) {
        var wirecastPeer = $store.getters.peers.find(function (item) { return item.master; });
        if (wirecastPeer) {
            wirecastPeer.isSuspended = true;
            __WEBPACK_IMPORTED_MODULE_0__peers__["a" /* closeConnection */](wirecastPeer);
            __WEBPACK_IMPORTED_MODULE_0__peers__["b" /* remove */](wirecastPeer);
            $store.dispatch("removePeer", wirecastPeer);
        }
    }
    var peer = __WEBPACK_IMPORTED_MODULE_0__peers__["c" /* createConnection */](session, peersIdentifier, username, reconnectCount, master, $store.getters.supportMusic, $store.getters.supportSimultaneousScreen);
    peer.isSuspended = suspended;
    var connection = peer.connection;
    log("-> Creating peer for", username, "(", peersIdentifier, ")");
    connection.onconnectionstatechange = function () {
        log(username, "Connection state change to", connection.connectionState);
        // This is a workaround for a Chrome bug,
        // where iceConnectionState does not go to "failed" state.
        // Instead, use connectionState to see if connection has failed.
        // https://bugs.chromium.org/p/chromium/issues/detail?id=935898
        if (__WEBPACK_IMPORTED_MODULE_3_webrtc_adapter__["a" /* default */].browserDetails.browser === "chrome") {
            var state = connection.connectionState;
            if (state == "failed") {
                onPeerConnectionFailed({ $store: $store, peer: peer, session: session });
            }
        }
    };
    connection.oniceconnectionstatechange = function () {
        var state = connection.iceConnectionState;
        log("-> ICE Connection state change for", username, "to", state);
        var handler = new Map([
            ["closed", onPeerConnectionClosed],
            ["disconnected", onPeerConnectionDisconnected],
            ["connected", onPeerConnectionConnected],
            ["failed", onPeerConnectionFailed],
        ]).get(state);
        if (!handler)
            return;
        handler({ $store: $store, peer: peer, session: session });
    };
    connection.onnegotiationneeded = function () { return catchConnectionError($store, function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_0__peers__["d" /* createOffer */](session, peer)];
    }); }); }); };
    peer.onReady = function () {
        $store.dispatch("addPeer", peer);
    };
    return peer;
}
function getPeer(peersIdentifier) {
    return __WEBPACK_IMPORTED_MODULE_0__peers__["e" /* getByIdentifier */](peersIdentifier);
}
function onCreateAnswer($socket, $store) {
    var _this = this;
    return function (payload) {
        var peersIdentifier = payload.peersIdentifier;
        var peerCreated = false;
        var peer = getPeer(peersIdentifier);
        if (!peer) {
            peer = createPeer($store, $socket.session, payload);
            peerCreated = true;
        }
        log("-> onCreateAnswer", peer.name);
        catchConnectionError($store, function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        log("Updating description for peer", peer.name);
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0__peers__["f" /* setRemoteDescription */](peer, payload)];
                    case 1:
                        _a.sent();
                        if (peerCreated) {
                            if (peer.master) {
                                __WEBPACK_IMPORTED_MODULE_0__peers__["g" /* setAnswererTransceiversForMaster */](peer, $store.getters.localStream);
                            }
                            else {
                                __WEBPACK_IMPORTED_MODULE_0__peers__["h" /* setAnswererTransceiversForParticipant */](peer, $store.getters.localStream);
                            }
                        }
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0__peers__["i" /* createAnswer */]($socket, peer)
                            // joining to a session
                        ];
                    case 2:
                        _a.sent();
                        // joining to a session
                        if ($store.getters.appState === "disconnected" || $store.getters.appState === "joining") {
                            log("-> Joined session successfully");
                            $store.dispatch("updateAppState", "connected");
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    };
}
function onICE() {
    return function (payload) {
        var peer = __WEBPACK_IMPORTED_MODULE_0__peers__["e" /* getByIdentifier */](payload.peersIdentifier);
        if (!peer) {
            console.error("No such peer", payload.peersIdentifier);
            return;
        }
        __WEBPACK_IMPORTED_MODULE_0__peers__["j" /* createCandidate */](peer, payload);
    };
}
function onCreateOffer($socket, $store) {
    return function (payload) {
        var peersIdentifier = payload.peersIdentifier, username = payload.username;
        var peer = getPeer(peersIdentifier);
        if (!peer) {
            peer = createPeer($store, $socket.session, payload);
            __WEBPACK_IMPORTED_MODULE_0__peers__["k" /* setOffererTransceiversForParticipant */](peer, $store.getters.localStream);
        }
        log("-> onCreateOffer", username);
        console.info("### Peers", __WEBPACK_IMPORTED_MODULE_0__peers__["l" /* getAll */]());
        peer.name = username;
    };
}
function onGotAnswer($store) {
    var _this = this;
    return function (payload) {
        var peer = __WEBPACK_IMPORTED_MODULE_0__peers__["e" /* getByIdentifier */](payload.peersIdentifier);
        log("Current peers", __WEBPACK_IMPORTED_MODULE_0__peers__["l" /* getAll */]());
        log("-> Got answer", peer.name);
        catchConnectionError($store, function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_0__peers__["f" /* setRemoteDescription */](peer, payload)];
        }); }); });
    };
}
function onGotChatMessages($store) {
    return function (payload) {
        $store.dispatch("gotChatMessages", payload.messages);
    };
}
function onDeletedChatMessage($store) {
    return function (payload) {
        if (payload.all === true) {
            $store.commit("deleteAllChatMessages");
            return;
        }
        $store.commit("deleteChatMessage", payload.index);
    };
}
function onPeerDisconnected($socket, $store) {
    return function (payload) {
        var peer = __WEBPACK_IMPORTED_MODULE_0__peers__["e" /* getByIdentifier */](payload.peersIdentifier);
        if (peer) {
            log("-> Disconnection from", peer.name);
            peer.isSuspended = true;
            __WEBPACK_IMPORTED_MODULE_0__peers__["a" /* closeConnection */](peer);
            __WEBPACK_IMPORTED_MODULE_0__peers__["b" /* remove */](peer);
            $store.dispatch("removePeer", peer);
        }
        if (!$store.getters.peers.length) {
            $store.dispatch("updateAppState", "disconnected");
            __WEBPACK_IMPORTED_MODULE_4__screenshare__["b" /* stopScreen */]($store, $socket);
        }
    };
}
function onDisconnect($socket, $store) {
    return function () {
        log("-> Disconnecting");
        __WEBPACK_IMPORTED_MODULE_4__screenshare__["b" /* stopScreen */]($store, $socket);
        $store.dispatch("clearPeers");
        $socket.session.socket.close();
        $store.dispatch("updateAppState", "disconnected");
    };
}
function onUpdateSharingStateResponse($store) {
    return function (payload) {
        log("-> UpdateSharingStateResponse. Allowed: ", payload.allowed);
        $store.dispatch("updateSharingScreenAndVideo", payload.allowed);
        if (!payload.allowed) {
            $store.dispatch("setScreenShareError", "SHARING_NOT_ALLOWED");
        }
    };
}
/**
 * Starts listening on given socket (must be SocketPlugin.Socket)
 * @param {SocketPlugin.Socket} $socket - socket to listen to
 * @param {Vuex} $store - vuex store to dispatch actions to
 */
function establish($socket, $store) {
    var session = $socket.session;
    $socket.on("createAnswer", onCreateAnswer($socket, $store));
    $socket.on("ice", onICE());
    $socket.on("createOffer", onCreateOffer($socket, $store));
    $socket.on("gotAnswer", onGotAnswer($store));
    $socket.on("gotChatMessages", onGotChatMessages($store));
    $socket.on("deletedChatMessage", onDeletedChatMessage($store));
    $socket.on("peerDisconnected", onPeerDisconnected($socket, $store));
    $socket.on("disconnect", onDisconnect($socket, $store));
    $socket.on("updateSharingStateResponse", onUpdateSharingStateResponse($store));
}


/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getFrameRate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_search_params__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_search_params___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_search_params__);

function getFrameRate() {
    var params = __WEBPACK_IMPORTED_MODULE_0_search_params__["parse"](window.location.search.replace(/^\?/, ""));
    var fps = params.find(function (param) { return param.name === "fps"; });
    if (fps) {
        return fps.value;
    }
}


/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createPeerGuid;
/* harmony export (immutable) */ __webpack_exports__["a"] = getPeerGuid;
/* harmony export (immutable) */ __webpack_exports__["c"] = getSessionGuid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid_v4__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/**
 * Guuid generation and storing
 * @module Guuid
 */


var peerGuidCookie = "net.telestream.webrtc.peerIdentifier";
function savePeerGuid(guid) {
    __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set(peerGuidCookie, guid);
}
function createPeerGuid() {
    var guid = __WEBPACK_IMPORTED_MODULE_0_uuid_v4___default()();
    savePeerGuid(guid);
    return guid;
}
function getPeerGuid() {
    return __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get(peerGuidCookie);
}
function getSessionGuid() {
    var pathname = window.location.pathname;
    var _a = pathname.match(/\/s\/([^\/|\?]+)/), sessionGuid = _a[1];
    if (!sessionGuid) {
        throw new Error("Could not find session guid in the URL pathname: " + pathname);
    }
    return sessionGuid;
}


/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return servers; });
/**
 * This module only holds the list of ICE servers available
 * @module ICE
 */
var servers = [{ urls: "stun:stun.l.google.com:19302" }];


/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugin_socket__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internationalization__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__polyfills__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__polyfills___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__polyfills__);







console.log("git commit: " + "e903286c13f85e69032f4d3b6fb5212b1cfa970c");
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3__plugin_socket__["a" /* default */], {
    store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
    onError: function (error) {
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch("setMinorError", "WEBSOCKET");
        console.error(error);
    },
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
    locale: __WEBPACK_IMPORTED_MODULE_5__internationalization__["a" /* getLanguage */](),
});
/* eslint-disable no-new */
/* tslint:disable:no-unused-expression */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: "#app",
    template: "<App/>",
    components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a },
    store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
    i18n: i18n,
});
if (window.Raven) {
    window.Raven.config("https://541a1dde7b5147c989e8d153a89a350f@sentry.io/197022").install();
}


/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = preferH264;
/* harmony export (immutable) */ __webpack_exports__["a"] = modifySdpForMusic;
/**
 * Sdp modification
 * @module Sdp
 */
function preferH264(originalSDP) {
    var separator = "\r\n";
    var lines = originalSDP.split(separator);
    lines.pop();
    var videoLine = null;
    var processingVideoSection = false;
    lines.forEach(function (line, index) {
        if (line.indexOf('m=video') === 0) {
            videoLine = index;
            processingVideoSection = true;
            return;
        }
        else if (line.indexOf('m=') === 0) {
            processingVideoSection = false;
        }
        if (!processingVideoSection) {
            return;
        }
        var matched = line.match(/a=rtpmap:([\d]+) H264/i);
        if (matched) {
            lines[videoLine] = lines[videoLine].replace(/(m=video [\d]+ [a-zA-Z\/]+) ([\d ]+)+/, function (_, str, codecs) {
                return str + " " +
                    (matched[1] + " " +
                        codecs
                            .split(" ")
                            .filter(function (codec) { return ![matched[1]].includes(codec); })
                            .join(" "));
            });
            processingVideoSection = false;
        }
    });
    var newSDP = "";
    lines.forEach(function (line) {
        newSDP += line + separator;
    });
    return newSDP;
}
function modifySdpForMusic(originalSDP) {
    var newSDP = "";
    var separator = "\r\n";
    var lines = originalSDP.split(separator);
    lines.pop();
    var audio_section_counter = 0;
    var processingAudioSection = false;
    lines.forEach(function (line) {
        if (line.indexOf('m=audio') === 0) {
            processingAudioSection = true;
            audio_section_counter++;
        }
        else if (line.indexOf('m=') === 0) {
            processingAudioSection = false;
        }
        if (processingAudioSection) {
            if (audio_section_counter == 1) {
                if (line.includes("fmtp")) {
                    if (line.includes("stereo")) {
                        line = line.replace('stereo=1', 'stereo=0');
                    }
                }
            }
            else if (audio_section_counter == 2) {
                if (line.includes("fmtp")) {
                    if (line.includes("stereo")) {
                        line += ";maxaveragebitrate=256000";
                    }
                }
            }
        }
        newSDP += line + separator;
    });
    return newSDP;
}


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

var LOCAL_PEER_CHAT_COLOR = "#029bd4";
var DEFAULT_GUEST_PEER_CHAT_COLOR = "#20986c";
var GUEST_PEERS_CHAT_COLORS = ["#20986c", "#431eac", "#3978be", "#41a558", "#6300bf", "#0064b8", "#14988d", "#0041b9"];
/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        chatFeatureEnabled: false,
        chatPanelOpened: true,
        localChatPeerId: undefined,
        peersColors: {},
        newMessageIndicator: false,
        messages: [],
    },
    getters: {
        showChat: function (state) {
            return state.chatFeatureEnabled && state.chatPanelOpened;
        },
        chatFeatureEnabled: function (state) {
            return state.chatFeatureEnabled;
        },
        chatPanelOpened: function (state) {
            return state.chatPanelOpened;
        },
        chatMessages: function (state) {
            return state.messages.sort(function (message1, message2) { return message1.index - message2.index; });
        },
        localChatPeerId: function (state) {
            return state.localChatPeerId;
        },
        getPeerColor: function (state) { return function (peerId) {
            return state.peersColors[peerId] || DEFAULT_GUEST_PEER_CHAT_COLOR;
        }; },
        getPeersWithColor: function (state) {
            return Object.keys(state.peersColors);
        },
        showNewMessageIndicator: function (state) {
            return state.newMessageIndicator && !state.chatPanelOpened;
        },
    },
    mutations: {
        addChatMessages: function (state, newMessages) {
            state.messages = __spreadArrays(state.messages, newMessages);
        },
        setChatFeatureEnabled: function (state, newChatFeatureStatus) {
            state.chatFeatureEnabled = newChatFeatureStatus;
        },
        setChatPanelOpened: function (state, newOpenedStatus) {
            state.chatPanelOpened = newOpenedStatus;
            if (!newOpenedStatus)
                state.newMessageIndicator = false;
        },
        setLocalChatPeerId: function (state, newPeerId) {
            state.localChatPeerId = newPeerId;
        },
        setLocalChatPeerColor: function (state, newPeerId) {
            var _a;
            state.peersColors = __assign(__assign({}, state.peersColors), (_a = {}, _a[newPeerId] = LOCAL_PEER_CHAT_COLOR, _a));
        },
        setPeerChatColor: function (state, newPeerId) {
            var _a;
            var colorIndex = Object.keys(state.peersColors).length % GUEST_PEERS_CHAT_COLORS.length;
            var color = GUEST_PEERS_CHAT_COLORS[colorIndex];
            state.peersColors = __assign(__assign({}, state.peersColors), (_a = {}, _a[newPeerId] = color, _a));
        },
        setNewMessageIndicator: function (state, newStatus) {
            state.newMessageIndicator = newStatus;
        },
        deleteChatMessage: function (state, deletedMessageIndex) {
            state.messages = state.messages.map(function (message) {
                if (message.index === deletedMessageIndex) {
                    return __assign(__assign({}, message), { content: "This message has been deleted.", deleted: true });
                }
                return message;
            });
        },
        deleteAllChatMessages: function (state) {
            state.messages = [];
        },
    },
    actions: {
        toggleChatPanelOpened: function (_a) {
            var getters = _a.getters, commit = _a.commit;
            commit("setChatPanelOpened", !getters.chatPanelOpened);
        },
        gotChatMessages: function (_a, newMessages) {
            var getters = _a.getters, commit = _a.commit;
            var messagePeers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["uniq"])(newMessages.map(function (message) { return message.peersIdentifier; }));
            var newPeers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["difference"])(messagePeers, getters.getPeersWithColor);
            if (newPeers.length > 0) {
                newPeers.forEach(function (peerId) { return commit("setPeerChatColor", peerId); });
            }
            commit("addChatMessages", newMessages);
            if (!getters.chatPanelOpened)
                commit("setNewMessageIndicator", true);
        },
        enableChat: function (_a, _b) {
            var commit = _a.commit;
            var peersIdentifier = _b.peersIdentifier;
            commit("setChatFeatureEnabled", true);
            commit("setChatPanelOpened", true);
            commit("setLocalChatPeerId", peersIdentifier);
            commit("setLocalChatPeerColor", peersIdentifier);
        },
        disableChat: function (_a) {
            var commit = _a.commit;
            commit("setChatFeatureEnabled", false);
            commit("setChatPanelOpened", false);
            commit("setLocalChatPeerId", undefined);
        },
    },
});


/***/ }),
/* 345 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAxOCAxNiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTggMTY7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojRkZGRkZGO30KPC9zdHlsZT4KPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CjxnIGlkPSJfeDMyX18xOF8iPgoJPGc+CgkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTExLjIsOS4xSDYuOGMtMC4yLDAtMC40LDAuMi0wLjQsMC40YzAsMC4yLDAuMiwwLjQsMC40LDAuNGg0LjRjMC4yLDAsMC40LTAuMiwwLjQtMC40CgkJCUMxMS43LDkuMywxMS41LDkuMSwxMS4yLDkuMXogTTEyLjEsNi40SDUuOWMtMC4yLDAtMC40LDAuMi0wLjQsMC40YzAsMC4yLDAuMiwwLjQsMC40LDAuNGg2LjJjMC4yLDAsMC40LTAuMiwwLjQtMC40CgkJCUMxMi41LDYuNiwxMi4zLDYuNCwxMi4xLDYuNHogTTksMS41Yy0zLjksMC03LjEsMi44LTcuMSw2LjJjMCwyLDEsMy43LDIuNyw0Ljh2My4xbDMuMS0xLjljMC40LDAuMSwwLjksMC4xLDEuMywwLjEKCQkJYzMuOSwwLDcuMS0yLjgsNy4xLTYuMkMxNi4xLDQuMywxMi45LDEuNSw5LDEuNXogTTksMTMuMWMtMC41LDAtMS0wLjEtMS41LTAuMmwtMi4xLDEuM2wwLTIuMWMtMS42LTEtMi42LTIuNi0yLjYtNC40CgkJCWMwLTIuOSwyLjgtNS4zLDYuMi01LjNzNi4yLDIuNCw2LjIsNS4zQzE1LjIsMTAuNywxMi40LDEzLjEsOSwxMy4xeiIvPgoJPC9nPgo8L2c+Cjwvc3ZnPgo="

/***/ }),
/* 346 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAxOCAxNiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTggMTY7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojRkZGRkZGO30KPC9zdHlsZT4KPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CjxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgo8cmVjdCB4PSI4LjciIHk9IjAuNCIgdHJhbnNmb3JtPSJtYXRyaXgoMC43MDcxIDAuNzA3MSAtMC43MDcxIDAuNzA3MSA4LjI5MjkgLTQuMDIwOCkiIGNsYXNzPSJzdDAiIHdpZHRoPSIwLjciIGhlaWdodD0iMTUuMiIvPgo8cmVjdCB4PSI4LjciIHk9IjAuNCIgdHJhbnNmb3JtPSJtYXRyaXgoLTAuNzA3MSAwLjcwNzEgLTAuNzA3MSAtMC43MDcxIDIxLjAyMDggNy4yOTI5KSIgY2xhc3M9InN0MCIgd2lkdGg9IjAuNyIgaGVpZ2h0PSIxNS4yIi8+Cjwvc3ZnPgo="

/***/ }),
/* 347 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(320)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(373),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(316)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(369),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5cf084d5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(312)
  __webpack_require__(311)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(365),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-382ff846",
  /* moduleIdentifier (server only) */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(143)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(310)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(364),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2cfd8303",
  /* moduleIdentifier (server only) */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(144)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(317)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(370),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-62225338",
  /* moduleIdentifier (server only) */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(145)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(306)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(360),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-00f5ebb8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(314)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(367),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-51967d42",
  /* moduleIdentifier (server only) */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(147)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(318)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(371),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-718baeb1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(308)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(362),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 360 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "streams-container",
    class: {
      'expanded-view': _vm.isAnyStreamExpanded
    }
  }, _vm._l((_vm.peers), function(peer) {
    return _c('stream', {
      key: peer.identifier,
      class: _vm.videoDisplayClass(peer.identifier),
      attrs: {
        "source": peer.stream,
        "screen-source": peer.screenStream,
        "is-local-stream": false,
        "label": peer.name,
        "id": peer.identifier,
        "peer": peer
      },
      nativeOn: {
        "click": function($event) {
          _vm.expandStream(peer.identifier)
        }
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 361 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-wrapper"
  }, [_c('span', [_vm._v("Microphone")]), _vm._v(" "), _vm._l((_vm.audioDevices), function(device) {
    return _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedDevice),
        expression: "selectedDevice"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": device.deviceId,
        "checked": _vm._q(_vm.selectedDevice, device.deviceId)
      },
      on: {
        "change": _vm.onChange,
        "__c": function($event) {
          _vm.selectedDevice = device.deviceId
        }
      }
    }), _vm._v("\n        " + _vm._s(device.label) + "\n    ")])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 362 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("chat-message-single " + (_vm.isLocal ? 'local-message' : ''))
  }, [_c('div', {
    staticClass: "chat-message-header"
  }, [_c('span', {
    staticClass: "chat-message-username"
  }, [_vm._v(_vm._s(_vm.username))]), _vm._v(" "), _c('span', {
    staticClass: "chat-message-time"
  }, [_vm._v(_vm._s(_vm.time))])]), _vm._v(" "), _c('div', {
    staticClass: "bubble-container"
  }, [(_vm.canBeDeleted) ? _c('div', {
    staticClass: "chat-bin"
  }, [_c('div', {
    on: {
      "click": _vm.deleteMessage
    }
  }, [_c('span', {
    staticClass: "delete-chat-message"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.chatBubbleCssClass,
    style: ({
      backgroundColor: _vm.messageBubbleColor
    })
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.linkedContent)
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-wrapper"
  }, [_c('span', [_vm._v("Camera")]), _vm._v(" "), _vm._l((_vm.videoDevices), function(device) {
    return _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedDevice),
        expression: "selectedDevice"
      }],
      attrs: {
        "disabled": _vm.sharingScreenOnly,
        "name": "video-device",
        "type": "radio"
      },
      domProps: {
        "value": device.deviceId,
        "checked": _vm._q(_vm.selectedDevice, device.deviceId)
      },
      on: {
        "change": _vm.onChange,
        "__c": function($event) {
          _vm.selectedDevice = device.deviceId
        }
      }
    }), _vm._v("\n        " + _vm._s(device.label) + "\n    ")])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 364 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "local"
  }, [_c('div', {
    staticClass: "dropdown",
    attrs: {
      "title": _vm.$t('button_settings_title')
    }
  }, [_c('i', {
    staticClass: "icon-settings-menu icons",
    attrs: {
      "data-settings-dropdown": ""
    },
    on: {
      "click": _vm.toggleDropdown
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dropdownVisible),
      expression: "dropdownVisible"
    }],
    staticClass: "dropdown-content"
  }, [_c('audio-device-select'), _vm._v(" "), _c('video-device-select'), _vm._v(" "), _c('options-menu-select')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "screenDropdown",
    attrs: {
      "title": _vm.$t('button_screen_share_title')
    }
  }, [_c('i', {
    class: ("" + ((_vm.sharingScreenAndVideo || _vm.sharingScreenOnly) ? 'icon-active-desktop-menu icons' : 'icon-desktop-menu icons')),
    attrs: {
      "data-screen-dropdown": ""
    },
    on: {
      "click": _vm.toggleScreenDropdown
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.supportScreensharing && _vm.isConnected && _vm.screenDropdownVisible),
      expression: "supportScreensharing && isConnected && screenDropdownVisible"
    }],
    staticClass: "dropdown-content"
  }, [_c('screen-menu-select')], 1)]), _vm._v(" "), _c('stream', {
    attrs: {
      "source": _vm.sourceStream,
      "is-local-stream": true,
      "id": _vm.localPeerId
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 365 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "join-prompt"
  }, [_c('my-stream'), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("content")) + ":\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }, _vm.onInput]
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.isButtonDisabled
    }
  }, [_vm._v(_vm._s(_vm.$t("button_join")))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 366 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stream",
    class: _vm.streamClass
  }, [_c('div', {
    staticClass: "controls-bg"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localInitialMode !== true),
      expression: "localInitialMode !== true"
    }],
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLocalStream && _vm.showBitrate),
      expression: "!isLocalStream && showBitrate"
    }],
    staticStyle: {
      "text-align": "left",
      "color": "aqua"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.bitrate) + "\n        ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showChatIcon),
      expression: "showChatIcon"
    }],
    attrs: {
      "title": _vm.$t('button_show_chat_title')
    },
    on: {
      "click": _vm.toggleChatPanelOpened
    }
  }, [_c('i', {
    staticClass: "icon-chat"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNewMessageIndicator),
      expression: "showNewMessageIndicator"
    }],
    staticClass: "icon-chat-new"
  })])]), _vm._v(" "), _c('button', {
    attrs: {
      "title": _vm.$t('button_mute_video_title')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleVideo($event)
      }
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLocalStream && (_vm.videoEnabled && !_vm.sharingScreenOnly)),
      expression: "isLocalStream && (videoEnabled && !sharingScreenOnly)"
    }],
    staticClass: "icon-cam-n-menu"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLocalStream && (!_vm.videoEnabled || _vm.sharingScreenOnly)),
      expression: "isLocalStream && (!videoEnabled || sharingScreenOnly)"
    }],
    staticClass: "icon-cam-menu"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLocalStream && _vm.videoEnabled),
      expression: "!isLocalStream && videoEnabled"
    }],
    staticClass: "icon-cam-n-menu"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLocalStream && !_vm.videoEnabled),
      expression: "!isLocalStream && !videoEnabled"
    }],
    staticClass: "icon-cam-menu"
  })]), _vm._v(" "), _c('button', {
    attrs: {
      "title": _vm.$t('button_mute_audio_title')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleAudio($event)
      }
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLocalStream && _vm.audioEnabled),
      expression: "!isLocalStream && audioEnabled"
    }],
    staticClass: "icon-audio-n-menu"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLocalStream && !_vm.audioEnabled),
      expression: "!isLocalStream && !audioEnabled"
    }],
    staticClass: "icon-audio-menu"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLocalStream && _vm.audioEnabled),
      expression: "isLocalStream && audioEnabled"
    }],
    staticClass: "icon-micro-n-menu"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLocalStream && !_vm.audioEnabled),
      expression: "isLocalStream && !audioEnabled"
    }],
    staticClass: "icon-micro-menu"
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRemoteAudioMuted),
      expression: "isRemoteAudioMuted"
    }],
    staticClass: "remote-icon"
  }, [_c('i', {
    staticClass: "icon-remote-micro-menu"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "container": ""
    }
  }, [_vm._m(0), _vm._v(" "), _c('spinner', {
    attrs: {
      "isVisible": !_vm.isVideoReady || _vm.isSuspended
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSuspended),
      expression: "isSuspended"
    }],
    staticClass: "connection-problem"
  }, [_vm._v("Connection problems...")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isTallyActive),
      expression: "isTallyActive"
    }],
    staticClass: "tally"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.videoEnabled),
      expression: "!videoEnabled"
    }],
    staticClass: "video-muted"
  }, [_c('i', {
    staticClass: "tsc-cam-menu"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.audioEnabled && _vm.isLocalStream),
      expression: "!audioEnabled && isLocalStream"
    }],
    staticClass: "audio-muted"
  }, [_c('i', {
    staticClass: "tsc-micro-menu"
  })]), _vm._v(" "), _c('video', {
    class: [_vm.videoFlipped ? 'main-video-mirror' : 'main-video', {
      'share-mode-video': _vm.isScreenShare
    }],
    attrs: {
      "autoplay": "",
      "data-original": ""
    }
  }), _vm._v(" "), _c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isScreenShare),
      expression: "isScreenShare"
    }],
    class: {
      'share-mode-screen': _vm.isScreenShare
    },
    attrs: {
      "autoplay": "",
      "data-screen": ""
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zoom"
  }, [_c('div', {
    staticClass: "move-center"
  }, [_c('div', {
    staticClass: "icons"
  }, [_c('i', {
    staticClass: "icon-zoom"
  }), _vm._v(" "), _c('i', {
    staticClass: "icon-grid"
  })])])])
}]}

/***/ }),
/* 367 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-wrapper"
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.supportSimultaneousScreen),
      expression: "supportSimultaneousScreen"
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedOption),
      expression: "selectedOption"
    }],
    attrs: {
      "type": "radio",
      "value": "screen-camera"
    },
    domProps: {
      "checked": _vm._q(_vm.selectedOption, "screen-camera")
    },
    on: {
      "change": function($event) {
        $event.preventDefault();
        _vm.onChange($event)
      },
      "__c": function($event) {
        _vm.selectedOption = "screen-camera"
      }
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t("screen-share-and-camera")) + "\n    ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedOption),
      expression: "selectedOption"
    }],
    attrs: {
      "type": "radio",
      "value": "screen-only"
    },
    domProps: {
      "checked": _vm._q(_vm.selectedOption, "screen-only")
    },
    on: {
      "change": function($event) {
        $event.preventDefault();
        _vm.onChange($event)
      },
      "__c": function($event) {
        _vm.selectedOption = "screen-only"
      }
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t("screen-share-only")) + "\n    ")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sharingScreenOnly || _vm.sharingScreenAndVideo),
      expression: "sharingScreenOnly || sharingScreenAndVideo"
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedOption),
      expression: "selectedOption"
    }],
    attrs: {
      "type": "radio",
      "value": "disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.selectedOption, "disabled")
    },
    on: {
      "change": function($event) {
        $event.preventDefault();
        _vm.onChange($event)
      },
      "__c": function($event) {
        _vm.selectedOption = "disabled"
      }
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t("stop-screen-share")) + "\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    attrs: {
      "id": "menu"
    }
  }, [_vm._m(0), _vm._v(" "), (!_vm.isErrorNoRTC && !_vm.isIOS && !_vm.isPure) ? _c('local') : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "remote-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.minorError),
      expression: "minorError"
    }],
    staticClass: "error-notification"
  }, [(_vm.minorError === 'WEBSOCKET') ? _c('p', [_vm._v("\n                    " + _vm._s(_vm.$t("error.websocket")) + "\n                ")]) : (_vm.minorError === 'CONNECTION') ? _c('p', [_vm._v("\n                    " + _vm._s(_vm.$t("error.connection")) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deviceError),
      expression: "deviceError"
    }],
    staticClass: "error-notification"
  }, [(_vm.deviceError === 'NO_DEVICES') ? _c('p', [_vm._v("\n                    No devices found.\n                ")]) : (_vm.deviceError === 'NOT_ALLOWED') ? _c('p', [_vm._v("\n                    Please allow Rendezvous to access your devices.\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.audioDeviceError.errorId),
      expression: "audioDeviceError.errorId"
    }],
    staticClass: "info-notification"
  }, [(_vm.audioDeviceError.errorId === 'NOT_ALLOWED') ? _c('p', [_vm._v("\n                    Please allow Rendezvous to access your microphone.\n                ")]) : (_vm.audioDeviceError.errorId === 'NOT_READABLE_DEVICE') ? _c('p', [_c('strong', [_vm._v(_vm._s(_vm.audioDeviceError.deviceName))]), _vm._v(" is not available. Please choose another microphone.\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.videoDeviceError.errorId),
      expression: "videoDeviceError.errorId"
    }],
    staticClass: "info-notification"
  }, [(_vm.videoDeviceError.errorId === 'NOT_ALLOWED') ? _c('p', [_vm._v("\n                    Please allow Rendezvous to access your camera.\n                ")]) : (_vm.videoDeviceError.errorId === 'NOT_READABLE_DEVICE') ? _c('p', [_c('strong', [_vm._v(_vm._s(_vm.videoDeviceError.deviceName))]), _vm._v(" is not available. Please choose another camera.\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.screenShareError),
      expression: "screenShareError"
    }],
    staticClass: "info-notification"
  }, [(_vm.screenShareError === 'SHARING_NOT_ALLOWED') ? _c('p', [_vm._v("\n                    Only one person can share both screen and camera.\n                    "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sharingScreenOnly),
      expression: "!sharingScreenOnly"
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.enableScreenshareOnly($event)
      }
    }
  }, [_vm._v("Share screen only & disable camera")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sharingScreenOnly),
      expression: "sharingScreenOnly"
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.disableScreenshareOnly($event)
      }
    }
  }, [_vm._v("Share camera instead of screen")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onShareScreenErrorDismiss($event)
      }
    }
  }, [_vm._v("Cancel")])]) : _c('p', [_vm._v("\n                    Failed to share the screen: "), _c('strong', [_vm._v(_vm._s(_vm.screenShareError))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sharingScreenAndVideo && !_vm.screenTallyActive),
      expression: "sharingScreenAndVideo && !screenTallyActive"
    }],
    staticClass: "info-notification"
  }, [_c('p', [_vm._v("\n                    You are screen sharing.\n                ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sharingScreenAndVideo && _vm.screenTallyActive),
      expression: "sharingScreenAndVideo && screenTallyActive"
    }],
    staticClass: "info-notification"
  }, [_c('p', [_vm._v("\n                    You are screen sharing. Your screen is live.\n                ")])]), _vm._v(" "), (_vm.isPure) ? _c('info-box', [_c('h1', {
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t("message.welcome.header")))]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.$t("message.welcome.content")) + "\n                ")]), _vm._v(" "), _c('join-prompt')], 1) : _vm._e(), _vm._v(" "), _c('info-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isIOS),
      expression: "isIOS"
    }]
  }, [_c('p', [_vm._v("\n                    To join to Wirecast Rendezvous session from an iOS device, please install Wirecast Go from the\n                    App Store.\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "text-centered"
  }, [_c('a', {
    staticStyle: {
      "display": "inline-block",
      "overflow": "hidden",
      "background": "url(//linkmaker.itunes.apple.com/assets/shared/badges/en-us/appstore-lrg.svg) no-repeat",
      "width": "135px",
      "height": "40px",
      "background-size": "contain"
    },
    attrs: {
      "href": "https://itunes.apple.com/us/app/wirecast-go/id987286934?mt=8"
    }
  })])]), _vm._v(" "), _c('info-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isError && _vm.isSessionUnknown),
      expression: "isError && isSessionUnknown"
    }]
  }, [_c('h1', {
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t("error.session_unknown.header")))]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.$t("error.session_unknown.content")) + "\n                ")])]), _vm._v(" "), _c('info-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isError && _vm.isSessionFull),
      expression: "isError && isSessionFull"
    }]
  }, [_c('h1', {
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t("error.session_full.header")))]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.$t("error.session_full.content")) + "\n                ")])]), _vm._v(" "), _c('info-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isError && _vm.isSessionAlreadyConnected),
      expression: "isError && isSessionAlreadyConnected"
    }]
  }, [_c('h1', {
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t("error.session_already_connected.header")))]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.$t("error.session_already_connected.content")) + "\n                ")])]), _vm._v(" "), _c('info-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isJoining),
      expression: "isJoining"
    }],
    staticClass: "joining centered"
  }, [_c('p', {
    staticClass: "text-centered"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("message.waiting.content")) + "\n                ")]), _vm._v(" "), _c('spinner', {
    staticClass: "static",
    attrs: {
      "is-visible": "true"
    }
  })], 1), _vm._v(" "), _c('info-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isErrorNoRTC),
      expression: "isErrorNoRTC"
    }]
  }, [_c('p', {
    staticClass: "text-centered"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("error.no_rtc.content")) + "\n                ")])]), _vm._v(" "), _c('info-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDisconnected),
      expression: "isDisconnected"
    }],
    staticClass: "centered"
  }, [_c('p', {
    staticClass: "text-centered"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("message.session_ended.content")) + "\n                ")])]), _vm._v(" "), _c('participants', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isConnected),
      expression: "isConnected"
    }]
  })], 1), _vm._v(" "), (_vm.chatEnabled) ? _c('chat-panel') : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "id": "app-bar"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(347)
    }
  })])
}]}

/***/ }),
/* 369 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-box-container"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_c('header', [_vm._t("header")], 2), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 370 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-stream"
  }, [_c('div', {
    staticClass: "dropdown",
    attrs: {
      "title": _vm.$t('button_settings_title')
    }
  }, [_c('i', {
    staticClass: "icon-settings-menu icons",
    attrs: {
      "data-settings-dropdown": ""
    },
    on: {
      "click": _vm.toggleDropdown
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dropdownVisible),
      expression: "dropdownVisible"
    }],
    staticClass: "dropdown-content"
  }, [_c('audio-device-select'), _vm._v(" "), _c('video-device-select'), _vm._v(" "), _c('options-menu-select', {
    attrs: {
      "initialMode": true
    }
  })], 1)]), _vm._v(" "), _c('stream', {
    attrs: {
      "source": _vm.sourceStream,
      "is-local-stream": true,
      "id": _vm.localPeerId,
      "local-initial-mode": true
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 371 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVisible),
      expression: "isVisible"
    }],
    attrs: {
      "id": "spinner"
    }
  }, [_c('div', {
    staticClass: "loading-spinner"
  })])])
},staticRenderFns: []}

/***/ }),
/* 372 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-wrapper"
  }, [_c('span', [_vm._v("Options")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sharingScreenOnly),
      expression: "!sharingScreenOnly"
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.videoFlipped),
      expression: "videoFlipped"
    }],
    attrs: {
      "name": "flip-video-horizontally",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.videoFlipped) ? _vm._i(_vm.videoFlipped, null) > -1 : (_vm.videoFlipped)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.videoFlipped,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.videoFlipped = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.videoFlipped = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.videoFlipped = $$c
        }
      }
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t("button_flip_video_horizontally")) + "\n    ")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.initialMode && _vm.supportMusic),
      expression: "!initialMode && supportMusic"
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.audioProcessingDisabled),
      expression: "audioProcessingDisabled"
    }],
    attrs: {
      "name": "disable-audio-processing",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.audioProcessingDisabled) ? _vm._i(_vm.audioProcessingDisabled, null) > -1 : (_vm.audioProcessingDisabled)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.audioProcessingDisabled,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.audioProcessingDisabled = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.audioProcessingDisabled = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.audioProcessingDisabled = $$c
        }
      }
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t("button_enable_music_mode")) + "\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showChat),
      expression: "showChat"
    }],
    staticClass: "chat-container"
  }, [_c('div', {
    staticClass: "chat-header"
  }, [_c('div', {
    staticClass: "chat-close"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(346)
    },
    on: {
      "click": _vm.closeChatPanel
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    ref: "chat-content",
    staticClass: "chat-content"
  }, [(_vm.noMessages) ? _c('div', {
    staticClass: "chat-empty-state"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (!_vm.noMessages) ? _c('div', {
    staticClass: "chat-messages"
  }, _vm._l((_vm.chatMessages), function(message, index) {
    return _c('message', {
      key: index,
      attrs: {
        "message": message
      }
    })
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "chat-footer"
  }, [_c('div', {
    class: ("footer-message-container " + (_vm.messageTextareaFocus ? 'footer-message-container-focus' : ''))
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    ref: "chat-message",
    staticClass: "message-textarea",
    attrs: {
      "maxlength": "10000",
      "rows": "1",
      "placeholder": "Send message..."
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.sendMessage($event)
      },
      "keydown": function($event) {
        _vm.autoResize($event)
      },
      "focus": function($event) {
        _vm.messageTextareaFocus = true
      },
      "focusout": function($event) {
        _vm.messageTextareaFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "send-button",
    on: {
      "click": function($event) {
        _vm.sendMessage($event)
      }
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-title"
  }, [_c('span', [_vm._v("Live chat")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-empty-state-content"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(345)
    }
  }), _vm._v(" "), _c('span', [_vm._v("Chat won't be visible in live broadcast.")]), _vm._v(" "), _c('span', [_vm._v("Be the first to write something")])])
}]}

/***/ })
]),[342]);


// WEBPACK FOOTER //
// js/app.a9ab5eeca7c63c7afd34.js